import React from "react";

export function NoOfClinics(props) {
  return (
    <svg
      width="19"
      height="22"
      viewBox="0 0 19 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.841 14.659L14.017 14.836L14.195 14.659C14.4039 14.4501 14.652 14.2843 14.925 14.1713C15.1979 14.0582 15.4905 14 15.786 14C16.0815 14 16.3741 14.0582 16.647 14.1713C16.92 14.2843 17.1681 14.4501 17.377 14.659C17.5859 14.8679 17.7517 15.116 17.8647 15.389C17.9778 15.6619 18.036 15.9545 18.036 16.25C18.036 16.5455 17.9778 16.8381 17.8647 17.111C17.7517 17.384 17.5859 17.6321 17.377 17.841L14.017 21.2L10.659 17.841C10.237 17.419 9.99999 16.8467 9.99999 16.25C9.99999 15.6533 10.237 15.081 10.659 14.659C11.081 14.237 11.6533 14 12.25 14C12.8467 14 13.419 14.237 13.841 14.659ZM8 13V15C6.4087 15 4.88258 15.6321 3.75736 16.7574C2.63214 17.8826 2 19.4087 2 21H0C2.41087e-05 18.9216 0.808937 16.9247 2.25547 15.4323C3.702 13.9398 5.67259 13.069 7.75 13.004L8 13ZM8 0C11.315 0 14 2.685 14 6C14.0006 7.55253 13.3991 9.04479 12.3221 10.163C11.2451 11.2812 9.77646 11.9383 8.225 11.996L8 12C4.685 12 2 9.315 2 6C1.99944 4.44747 2.6009 2.95521 3.67791 1.83699C4.75491 0.718771 6.22354 0.0617214 7.775 0.00399995L8 0ZM8 2C5.79 2 4 3.79 4 6C4 8.21 5.79 10 8 10C10.21 10 12 8.21 12 6C12 3.79 10.21 2 8 2Z"
        fill="#E24020"
      />
    </svg>
  );
}

export function TotalPatients(props) {
  return (
    <svg
      width="16"
      height="21"
      viewBox="0 0 16 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 21C0 18.8783 0.842855 16.8434 2.34315 15.3431C3.84344 13.8429 5.87827 13 8 13C10.1217 13 12.1566 13.8429 13.6569 15.3431C15.1571 16.8434 16 18.8783 16 21H0ZM9 15.083V19H13.659C13.3015 17.9914 12.6812 17.0966 11.8621 16.408C11.0431 15.7193 10.055 15.2619 9 15.083ZM7 19V15.083C5.945 15.2619 4.95691 15.7193 4.13785 16.408C3.31879 17.0966 2.69847 17.9914 2.341 19H7ZM8 12C4.685 12 2 9.315 2 6C2 2.685 4.685 0 8 0C11.315 0 14 2.685 14 6C14 9.315 11.315 12 8 12ZM8 10C10.21 10 12 8.21 12 6C12 3.79 10.21 2 8 2C5.79 2 4 3.79 4 6C4 8.21 5.79 10 8 10Z"
        fill="#3ECD96"
      />
    </svg>
  );
}

export function TotalTherapists(props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_554_3932)">
        <path
          d="M4 21.5319C4 19.4554 4.84285 17.4638 6.34315 15.9955C7.84344 14.5271 9.87827 13.7022 12 13.7022C14.1217 13.7022 16.1566 14.5271 17.6569 15.9955C19.1571 17.4638 20 19.4554 20 21.5319H4ZM13 15.7408V19.5745H17.659C17.3015 18.5874 16.6812 17.7116 15.8621 17.0376C15.0431 16.3636 14.055 15.916 13 15.7408ZM11 19.5745V15.7408C9.945 15.916 8.95691 16.3636 8.13785 17.0376C7.31879 17.7116 6.69847 18.5874 6.341 19.5745H11ZM12 12.7234C8.685 12.7234 6 10.0956 6 6.8511C6 3.60663 8.685 0.97876 12 0.97876C15.315 0.97876 18 3.60663 18 6.8511C18 10.0956 15.315 12.7234 12 12.7234ZM12 10.766C14.21 10.766 16 9.01408 16 6.8511C16 4.68812 14.21 2.93621 12 2.93621C9.79 2.93621 8 4.68812 8 6.8511C8 9.01408 9.79 10.766 12 10.766Z"
          fill="#E24020"
        />
      </g>
      <defs>
        <clipPath id="clip0_554_3932">
          <rect width="24" height="23.4894" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function Arrow(props) {
  return (
    <svg
      width="10"
      height="11"
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.333496 9.22668L7.3935 2.16668H3.00016V0.833344H9.66683V7.50001H8.3335V3.10668L1.2735 10.1667L0.333496 9.22668Z"
        fill="#22C687"
      />
    </svg>
  );
}

export function Calender(props) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.75 3.50001C1.75 2.85568 2.27233 2.33334 2.91667 2.33334H11.0833C11.7277 2.33334 12.25 2.85568 12.25 3.50001V11.6667C12.25 12.311 11.7277 12.8333 11.0833 12.8333H2.91667C2.27233 12.8333 1.75 12.311 1.75 11.6667V3.50001Z"
        stroke="#E24020"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.3335 1.16666V3.49999"
        stroke="#E24020"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.6665 1.16666V3.49999"
        stroke="#E24020"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.75 5.83334H12.25"
        stroke="#E24020"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function EditIcon(props) {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.1665 1.5C14.3854 1.28113 14.6452 1.10752 14.9312 0.989064C15.2171 0.870613 15.5236 0.809647 15.8332 0.809647C16.1427 0.809647 16.4492 0.870613 16.7352 0.989064C17.0211 1.10752 17.281 1.28113 17.4998 1.5C17.7187 1.71887 17.8923 1.97871 18.0108 2.26468C18.1292 2.55064 18.1902 2.85714 18.1902 3.16667C18.1902 3.4762 18.1292 3.7827 18.0108 4.06866C17.8923 4.35463 17.7187 4.61447 17.4998 4.83334L6.24984 16.0833L1.6665 17.3333L2.9165 12.75L14.1665 1.5Z"
        stroke="black"
        strokeOpacity="0.5"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function DeleteIcon(props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 21C6.45 21 5.979 20.804 5.587 20.412C5.195 20.02 4.99934 19.5493 5 19V6C4.71667 6 4.479 5.904 4.287 5.712C4.095 5.52 3.99934 5.28267 4 5C4 4.71667 4.096 4.479 4.288 4.287C4.48 4.095 4.71734 3.99934 5 4H9C9 3.71667 9.096 3.479 9.288 3.287C9.48 3.095 9.71734 2.99934 10 3H14C14.2833 3 14.521 3.096 14.713 3.288C14.905 3.48 15.0007 3.71734 15 4H19C19.2833 4 19.521 4.096 19.713 4.288C19.905 4.48 20.0007 4.71734 20 5C20 5.28334 19.904 5.521 19.712 5.713C19.52 5.905 19.2827 6.00067 19 6V19C19 19.55 18.804 20.021 18.412 20.413C18.02 20.805 17.5493 21.0007 17 21H7ZM7 6V19H17V6H7ZM9 16C9 16.2833 9.096 16.521 9.288 16.713C9.48 16.905 9.71734 17.0007 10 17C10.2833 17 10.521 16.904 10.713 16.712C10.905 16.52 11.0007 16.2827 11 16V9C11 8.71667 10.904 8.479 10.712 8.287C10.52 8.095 10.2827 7.99934 10 8C9.71667 8 9.479 8.096 9.287 8.288C9.095 8.48 8.99934 8.71734 9 9V16ZM13 16C13 16.2833 13.096 16.521 13.288 16.713C13.48 16.905 13.7173 17.0007 14 17C14.2833 17 14.521 16.904 14.713 16.712C14.905 16.52 15.0007 16.2827 15 16V9C15 8.71667 14.904 8.479 14.712 8.287C14.52 8.095 14.2827 7.99934 14 8C13.7167 8 13.479 8.096 13.287 8.288C13.095 8.48 12.9993 8.71734 13 9V16Z"
        fill="#7F7F7F"
      />
    </svg>
  );
}

export function ViewIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_792_6316)">
        <path
          d="M0.833252 9.99999C0.833252 9.99999 4.16659 3.33333 9.99992 3.33333C15.8333 3.33333 19.1666 9.99999 19.1666 9.99999C19.1666 9.99999 15.8333 16.6667 9.99992 16.6667C4.16659 16.6667 0.833252 9.99999 0.833252 9.99999Z"
          stroke="#7D7D7D"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
          stroke="#7D7D7D"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_792_6316">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function DashboardIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5833 12.5C14.2064 12.5 13.674 12.5521 13.1198 12.628C12.8608 12.6635 12.6634 12.8609 12.6279 13.1199C12.552 13.6741 12.4999 14.2065 12.4999 14.5833C12.4999 14.9602 12.552 15.4926 12.6279 16.0468C12.6634 16.3058 12.8608 16.5032 13.1198 16.5387C13.674 16.6146 14.2064 16.6667 14.5833 16.6667C14.9601 16.6667 15.4925 16.6146 16.0467 16.5387C16.3057 16.5032 16.5031 16.3058 16.5386 16.0468C16.6145 15.4926 16.6666 14.9602 16.6666 14.5833C16.6666 14.2065 16.6145 13.6741 16.5386 13.1199C16.5031 12.8609 16.3057 12.6635 16.0467 12.628C15.4925 12.5521 14.9601 12.5 14.5833 12.5ZM12.8936 10.9768C11.8937 11.1137 11.1136 11.8938 10.9767 12.8937C10.8981 13.4672 10.8333 14.0901 10.8333 14.5833C10.8333 15.0765 10.8981 15.6995 10.9767 16.273C11.1136 17.2729 11.8937 18.053 12.8936 18.1899C13.4671 18.2685 14.0901 18.3333 14.5833 18.3333C15.0765 18.3333 15.6994 18.2685 16.2729 18.1899C17.2728 18.053 18.0529 17.2729 18.1898 16.273C18.2684 15.6995 18.3333 15.0765 18.3333 14.5833C18.3333 14.0901 18.2684 13.4672 18.1898 12.8937C18.0529 11.8938 17.2728 11.1137 16.2729 10.9768C15.6994 10.8982 15.0765 10.8333 14.5833 10.8333C14.0901 10.8333 13.4671 10.8982 12.8936 10.9768Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.41675 12.5C5.03993 12.5 4.50752 12.5521 3.95326 12.628C3.69432 12.6635 3.49687 12.8609 3.46141 13.1199C3.3855 13.6741 3.33341 14.2065 3.33341 14.5833C3.33341 14.9602 3.3855 15.4926 3.46141 16.0468C3.49687 16.3058 3.69432 16.5032 3.95326 16.5387C4.50752 16.6146 5.03993 16.6667 5.41675 16.6667C5.79357 16.6667 6.32598 16.6146 6.88024 16.5387C7.13918 16.5032 7.33662 16.3058 7.37209 16.0468C7.44799 15.4926 7.50008 14.9602 7.50008 14.5833C7.50008 14.2065 7.44799 13.6741 7.37209 13.1199C7.33662 12.8609 7.13918 12.6635 6.88024 12.628C6.32598 12.5521 5.79357 12.5 5.41675 12.5ZM3.72711 10.9768C2.72719 11.1137 1.9471 11.8938 1.81016 12.8937C1.73161 13.4672 1.66675 14.0901 1.66675 14.5833C1.66675 15.0765 1.73161 15.6995 1.81016 16.273C1.9471 17.2729 2.72719 18.053 3.72711 18.1899C4.30062 18.2685 4.92355 18.3333 5.41675 18.3333C5.90995 18.3333 6.53288 18.2685 7.10639 18.1899C8.1063 18.053 8.8864 17.2729 9.02334 16.273C9.10188 15.6995 9.16675 15.0765 9.16675 14.5833C9.16675 14.0901 9.10188 13.4672 9.02334 12.8937C8.8864 11.8938 8.1063 11.1137 7.10639 10.9768C6.53288 10.8982 5.90995 10.8333 5.41675 10.8333C4.92355 10.8333 4.30062 10.8982 3.72711 10.9768Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5833 3.33332C14.2064 3.33332 13.674 3.38541 13.1198 3.46132C12.8608 3.49678 12.6634 3.69423 12.6279 3.95317C12.552 4.50743 12.4999 5.03984 12.4999 5.41666C12.4999 5.79347 12.552 6.32589 12.6279 6.88015C12.6634 7.13909 12.8608 7.33653 13.1198 7.37199C13.674 7.4479 14.2064 7.49999 14.5833 7.49999C14.9601 7.49999 15.4925 7.4479 16.0467 7.37199C16.3057 7.33653 16.5031 7.13909 16.5386 6.88015C16.6145 6.32589 16.6666 5.79347 16.6666 5.41666C16.6666 5.03984 16.6145 4.50743 16.5386 3.95317C16.5031 3.69423 16.3057 3.49678 16.0467 3.46132C15.4925 3.38541 14.9601 3.33332 14.5833 3.33332ZM12.8936 1.81007C11.8937 1.94701 11.1136 2.7271 10.9767 3.72702C10.8981 4.30053 10.8333 4.92346 10.8333 5.41666C10.8333 5.90986 10.8981 6.53279 10.9767 7.10629C11.1136 8.10621 11.8937 8.8863 12.8936 9.02325C13.4671 9.10179 14.0901 9.16666 14.5833 9.16666C15.0765 9.16666 15.6994 9.10179 16.2729 9.02325C17.2728 8.8863 18.0529 8.10621 18.1898 7.10629C18.2684 6.53279 18.3333 5.90986 18.3333 5.41666C18.3333 4.92346 18.2684 4.30053 18.1898 3.72702C18.0529 2.7271 17.2728 1.94701 16.2729 1.81007C15.6994 1.73152 15.0765 1.66666 14.5833 1.66666C14.0901 1.66666 13.4671 1.73152 12.8936 1.81007Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.41675 3.33332C5.03993 3.33332 4.50752 3.38541 3.95326 3.46132C3.69432 3.49678 3.49687 3.69423 3.46141 3.95317C3.3855 4.50743 3.33341 5.03984 3.33341 5.41666C3.33341 5.79347 3.3855 6.32589 3.46141 6.88015C3.49687 7.13909 3.69432 7.33653 3.95326 7.37199C4.50752 7.4479 5.03993 7.49999 5.41675 7.49999C5.79357 7.49999 6.32598 7.4479 6.88024 7.37199C7.13918 7.33653 7.33662 7.13909 7.37209 6.88015C7.44799 6.32589 7.50008 5.79347 7.50008 5.41666C7.50008 5.03984 7.44799 4.50743 7.37209 3.95317C7.33662 3.69423 7.13918 3.49678 6.88024 3.46132C6.32598 3.38541 5.79357 3.33332 5.41675 3.33332ZM3.72711 1.81007C2.72719 1.94701 1.9471 2.7271 1.81016 3.72702C1.73161 4.30053 1.66675 4.92346 1.66675 5.41666C1.66675 5.90986 1.73161 6.53279 1.81016 7.10629C1.9471 8.10621 2.72719 8.8863 3.72711 9.02325C4.30062 9.10179 4.92355 9.16666 5.41675 9.16666C5.90995 9.16666 6.53288 9.10179 7.10639 9.02325C8.1063 8.8863 8.8864 8.10621 9.02334 7.10629C9.10188 6.53279 9.16675 5.90986 9.16675 5.41666C9.16675 4.92346 9.10188 4.30053 9.02334 3.72702C8.8864 2.7271 8.1063 1.94701 7.10639 1.81007C6.53288 1.73152 5.90995 1.66666 5.41675 1.66666C4.92355 1.66666 4.30062 1.73152 3.72711 1.81007Z"
        fill={props.color}
      />
    </svg>
  );
}

export const AdminIcon = (props) => {
  return (
    <svg
      width="16"
      height="19"
      viewBox="0 0 16 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00016 11.6668V13.3335C5.67408 13.3335 4.40231 13.8603 3.46463 14.798C2.52695 15.7356 2.00016 17.0074 2.00016 18.3335H0.333496C0.333496 16.5654 1.03588 14.8697 2.28612 13.6195C3.53636 12.3692 5.23205 11.6668 7.00016 11.6668ZM7.00016 10.8335C4.23766 10.8335 2.00016 8.596 2.00016 5.8335C2.00016 3.071 4.23766 0.833496 7.00016 0.833496C9.76266 0.833496 12.0002 3.071 12.0002 5.8335C12.0002 8.596 9.76266 10.8335 7.00016 10.8335ZM7.00016 9.16683C8.84183 9.16683 10.3335 7.67516 10.3335 5.8335C10.3335 3.99183 8.84183 2.50016 7.00016 2.50016C5.1585 2.50016 3.66683 3.99183 3.66683 5.8335C3.66683 7.67516 5.1585 9.16683 7.00016 9.16683ZM14.5002 14.1668H15.3335V18.3335H8.66683V14.1668H9.50016V13.3335C9.50016 12.6705 9.76355 12.0346 10.2324 11.5657C10.7012 11.0969 11.3371 10.8335 12.0002 10.8335C12.6632 10.8335 13.2991 11.0969 13.7679 11.5657C14.2368 12.0346 14.5002 12.6705 14.5002 13.3335V14.1668ZM12.8335 14.1668V13.3335C12.8335 13.1125 12.7457 12.9005 12.5894 12.7442C12.4331 12.588 12.2212 12.5002 12.0002 12.5002C11.7791 12.5002 11.5672 12.588 11.4109 12.7442C11.2546 12.9005 11.1668 13.1125 11.1668 13.3335V14.1668H12.8335Z"
        fill={props.color}
      />
    </svg>
  );
};

export function ClinicIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.333496 18.3333C0.333496 16.5652 1.03588 14.8695 2.28612 13.6193C3.53636 12.3691 5.23205 11.6667 7.00016 11.6667C8.76827 11.6667 10.464 12.3691 11.7142 13.6193C12.9645 14.8695 13.6668 16.5652 13.6668 18.3333H0.333496ZM7.8335 13.4025V16.6667H11.716C11.4181 15.8262 10.9012 15.0805 10.2186 14.5066C9.53607 13.9328 8.71267 13.5516 7.8335 13.4025ZM6.16683 16.6667V13.4025C5.28766 13.5516 4.46425 13.9328 3.7817 14.5066C3.09916 15.0805 2.58222 15.8262 2.28433 16.6667H6.16683ZM7.00016 10.8333C4.23766 10.8333 2.00016 8.59584 2.00016 5.83334C2.00016 3.07084 4.23766 0.833344 7.00016 0.833344C9.76266 0.833344 12.0002 3.07084 12.0002 5.83334C12.0002 8.59584 9.76266 10.8333 7.00016 10.8333ZM7.00016 9.16668C8.84183 9.16668 10.3335 7.67501 10.3335 5.83334C10.3335 3.99168 8.84183 2.50001 7.00016 2.50001C5.1585 2.50001 3.66683 3.99168 3.66683 5.83334C3.66683 7.67501 5.1585 9.16668 7.00016 9.16668Z"
        fill={props.color}
      />
    </svg>
  );
}

export function SettingsIcon(props) {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6244 6.40867C16.6331 5.75775 16.3891 5.1041 15.8924 4.60743C15.3957 4.11077 14.7421 3.86676 14.0912 3.87542C14.0909 3.87543 14.0914 3.87542 14.0912 3.87542C13.7314 3.88032 13.3717 3.9624 13.0407 4.12167C12.922 4.17874 12.8069 4.24573 12.6967 4.32264C12.6542 4.35225 12.5995 4.35901 12.5517 4.33918C12.5039 4.31936 12.47 4.27593 12.4609 4.225C12.4374 4.09265 12.4034 3.96391 12.3598 3.83965C12.2383 3.49292 12.0426 3.18109 11.7916 2.92324C11.7915 2.92307 11.7918 2.92342 11.7916 2.92324C11.3375 2.45685 10.7022 2.16666 9.99984 2.16666C9.29744 2.16666 8.66271 2.45632 8.20857 2.92271C8.2084 2.92289 8.20874 2.92254 8.20857 2.92271C7.95763 3.18056 7.76137 3.49292 7.63987 3.83965C7.59632 3.96391 7.56232 4.09265 7.53873 4.225C7.52965 4.27593 7.49574 4.31936 7.44796 4.33918C7.40014 4.35901 7.34548 4.35225 7.30302 4.32263C7.19275 4.24573 7.07767 4.17874 6.95902 4.12167C6.62793 3.9624 6.26902 3.88033 5.90925 3.87543C5.909 3.87543 5.90949 3.87544 5.90925 3.87543C5.25833 3.86677 4.60395 4.11077 4.10728 4.60743C3.61061 5.1041 3.36661 5.75775 3.37527 6.40867C3.37528 6.40891 3.37527 6.40842 3.37527 6.40867C3.38016 6.76843 3.46225 7.12808 3.62151 7.45917C3.67859 7.57782 3.74558 7.6929 3.82248 7.80317C3.8521 7.84563 3.85886 7.90029 3.83902 7.94811C3.81921 7.9959 3.77578 8.0298 3.72485 8.03888C3.59249 8.06247 3.46375 8.09648 3.33948 8.14003C2.99276 8.26152 2.68094 8.45728 2.42309 8.70821C2.42291 8.70838 2.42326 8.70803 2.42309 8.70821C1.9567 9.16235 1.6665 9.7976 1.6665 10.5C1.6665 11.2024 1.95617 11.8371 2.42256 12.2913C2.42274 12.2914 2.42239 12.2911 2.42256 12.2913C2.68041 12.5422 2.99276 12.7385 3.33948 12.86C3.46374 12.9035 3.59249 12.9375 3.72485 12.9611C3.77578 12.9702 3.81921 13.0041 3.83902 13.0519C3.85886 13.0997 3.8521 13.1543 3.82248 13.1968C3.74558 13.3071 3.67859 13.4222 3.62151 13.5408C3.46225 13.8719 3.38017 14.2308 3.37528 14.5906C3.37528 14.5908 3.37529 14.5903 3.37528 14.5906C3.36662 15.2415 3.61061 15.8959 4.10728 16.3925C4.60395 16.8892 5.2576 17.1332 5.90852 17.1246C5.90876 17.1246 5.90827 17.1246 5.90852 17.1246C6.26828 17.1197 6.62792 17.0376 6.959 16.8783C7.07766 16.8212 7.19274 16.7543 7.30301 16.6773C7.34548 16.6477 7.40013 16.641 7.44796 16.6608C7.49574 16.6806 7.52965 16.7241 7.53873 16.775C7.56232 16.9073 7.59633 17.0361 7.63988 17.1604C7.76137 17.5071 7.95712 17.8189 8.20805 18.0767C8.20822 18.0769 8.20788 18.0766 8.20805 18.0767C8.66219 18.5431 9.29744 18.8333 9.99984 18.8333C10.7022 18.8333 11.337 18.5437 11.7911 18.0773C11.7913 18.0771 11.7909 18.0774 11.7911 18.0773C12.042 17.8194 12.2383 17.5071 12.3598 17.1604C12.4033 17.0361 12.4374 16.9073 12.4609 16.775C12.47 16.7241 12.5039 16.6806 12.5517 16.6608C12.5995 16.641 12.6542 16.6477 12.6967 16.6773C12.8069 16.7543 12.922 16.8212 13.0407 16.8783C13.3718 17.0376 13.7307 17.1197 14.0904 17.1245C14.0907 17.1245 14.0902 17.1245 14.0904 17.1245C14.7413 17.1332 15.3957 16.8892 15.8924 16.3925C16.3891 15.8959 16.6331 15.2422 16.6244 14.5913C16.6244 14.5911 16.6244 14.5916 16.6244 14.5913C16.6195 14.2316 16.5374 13.8719 16.3782 13.5408C16.3211 13.4222 16.2541 13.3071 16.1772 13.1968C16.1476 13.1543 16.1408 13.0997 16.1607 13.0519C16.1805 13.0041 16.2239 12.9702 16.2748 12.9611C16.4072 12.9375 16.5359 12.9035 16.6602 12.86C17.0069 12.7385 17.3187 12.5427 17.5766 12.2918C17.5768 12.2916 17.5764 12.2919 17.5766 12.2918C18.043 11.8376 18.3332 11.2024 18.3332 10.5C18.3332 9.7976 18.0435 9.16286 17.5771 8.70872C17.5769 8.70855 17.5773 8.70889 17.5771 8.70872C17.3193 8.45779 17.0069 8.26153 16.6602 8.14003C16.5359 8.09648 16.4072 8.06247 16.2748 8.03888C16.2239 8.0298 16.1805 7.9959 16.1607 7.94811C16.1408 7.90029 16.1476 7.84563 16.1772 7.80317C16.2541 7.6929 16.3211 7.57781 16.3782 7.45916C16.5374 7.12807 16.6195 6.76843 16.6244 6.40867C16.6244 6.40891 16.6244 6.40842 16.6244 6.40867ZM14.7139 5.78594C14.4252 5.49726 13.9741 5.46369 13.6501 5.68967C13.1585 6.03253 12.5056 6.12434 11.9133 5.87873C11.3225 5.63375 10.9254 5.10819 10.8201 4.51748C10.7508 4.12857 10.4081 3.83332 9.99984 3.83332C9.59158 3.83332 9.24885 4.12857 9.17953 4.51748C9.07423 5.10819 8.67715 5.63375 8.08637 5.87872C7.49407 6.12434 6.8412 6.03252 6.34961 5.68967C6.02559 5.46369 5.57447 5.49726 5.28579 5.78594C4.99711 6.07463 4.96354 6.52574 5.18952 6.84976C5.53237 7.34136 5.62418 7.99422 5.37857 8.58652C5.13359 9.1773 4.60804 9.57439 4.01732 9.67968C3.62841 9.74901 3.33317 10.0917 3.33317 10.5C3.33317 10.9082 3.62841 11.251 4.01732 11.3203C4.60804 11.4256 5.13359 11.8227 5.37857 12.4135C5.62419 13.0058 5.53237 13.6586 5.18952 14.1502C4.96354 14.4742 4.99711 14.9254 5.28579 15.214C5.57448 15.5027 6.02558 15.5363 6.3496 15.3103C6.8412 14.9675 7.49406 14.8756 8.08637 15.1213C8.67714 15.3662 9.07424 15.8918 9.17953 16.4825C9.24886 16.8714 9.59158 17.1667 9.99984 17.1667C10.4081 17.1667 10.7508 16.8714 10.8201 16.4825C10.9254 15.8918 11.3225 15.3662 11.9133 15.1213C12.5056 14.8756 13.1585 14.9675 13.6501 15.3103C13.9741 15.5363 14.4252 15.5027 14.7139 15.214C15.0026 14.9254 15.0361 14.4742 14.8102 14.1502C14.4673 13.6586 14.3755 13.0058 14.6211 12.4135C14.8661 11.8227 15.3916 11.4256 15.9824 11.3203C16.3713 11.251 16.6665 10.9082 16.6665 10.5C16.6665 10.0917 16.3713 9.74901 15.9824 9.67968C15.3916 9.57439 14.8661 9.1773 14.6211 8.58653C14.3755 7.99422 14.4673 7.34135 14.8102 6.84976C15.0361 6.52574 15.0026 6.07463 14.7139 5.78594Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99984 12.1667C10.9203 12.1667 11.6665 11.4205 11.6665 10.5C11.6665 9.57952 10.9203 8.83332 9.99984 8.83332C9.07936 8.83332 8.33317 9.57952 8.33317 10.5C8.33317 11.4205 9.07936 12.1667 9.99984 12.1667ZM9.99984 13.8333C11.8408 13.8333 13.3332 12.3409 13.3332 10.5C13.3332 8.65904 11.8408 7.16666 9.99984 7.16666C8.15889 7.16666 6.6665 8.65904 6.6665 10.5C6.6665 12.3409 8.15889 13.8333 9.99984 13.8333Z"
        fill={props.color}
      />
    </svg>
  );
}

export function LogoutIcon(props) {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.19107 13.0006C9.65098 12.9832 10.0379 13.342 10.0552 13.8019C10.0944 14.8387 10.1494 15.5955 10.2034 16.138C10.2566 16.6724 10.5792 16.9939 11.0289 17.0488C11.5591 17.1136 12.307 17.1667 13.3334 17.1667C14.3598 17.1667 15.1078 17.1136 15.638 17.0488C16.0874 16.9939 16.4101 16.6722 16.4634 16.1378C16.5637 15.1307 16.6667 13.3907 16.6667 10.5C16.6667 7.60933 16.5637 5.86935 16.4634 4.86224C16.4101 4.32778 16.0874 4.00615 15.638 3.95121C15.1078 3.88639 14.3598 3.83334 13.3334 3.83334C12.307 3.83334 11.5591 3.88639 11.0289 3.9512C10.5792 4.00617 10.2566 4.32766 10.2034 4.86199C10.1494 5.40455 10.0944 6.16129 10.0552 7.19811C10.0379 7.65802 9.65098 8.01678 9.19107 7.99942C8.73116 7.98205 8.3724 7.59515 8.38976 7.13524C8.42994 6.07104 8.4869 5.27953 8.54495 4.69677C8.667 3.47163 9.52117 2.45643 10.8266 2.29685C11.4343 2.22256 12.2507 2.16668 13.3334 2.16668C14.4161 2.16668 15.2325 2.22257 15.8402 2.29686C17.1458 2.45646 17.9998 3.47213 18.1218 4.69703C18.2293 5.77558 18.3334 7.57374 18.3334 10.5C18.3334 13.4263 18.2293 15.2244 18.1218 16.303C17.9998 17.5279 17.1458 18.5436 15.8402 18.7032C15.2325 18.7775 14.4161 18.8333 13.3334 18.8333C12.2507 18.8333 11.4343 18.7775 10.8266 18.7032C9.52117 18.5436 8.667 17.5284 8.54495 16.3032C8.4869 15.7205 8.42994 14.929 8.38976 13.8648C8.3724 13.4049 8.73116 13.018 9.19107 13.0006Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.00576 12.8274C6.3312 13.1528 6.3312 13.6805 6.00576 14.0059C5.68032 14.3314 5.15269 14.3314 4.82725 14.0059L1.91058 11.0893C1.58514 10.7638 1.58514 10.2362 1.91058 9.91074L4.82725 6.99408C5.15269 6.66864 5.68032 6.66864 6.00576 6.99408C6.3312 7.31951 6.3312 7.84715 6.00576 8.17259L4.51168 9.66667H12.4998C12.9601 9.66667 13.3332 10.0398 13.3332 10.5C13.3332 10.9602 12.9601 11.3333 12.4998 11.3333L4.51168 11.3333L6.00576 12.8274Z"
        fill={props.color}
      />
    </svg>
  );
}

export function SearchIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.7192 18.3125L16.0114 14.6325C17.4506 12.837 18.1476 10.5578 17.959 8.26385C17.7705 5.96985 16.7106 3.83533 14.9975 2.29919C13.2844 0.763054 11.0481 -0.0579415 8.74862 0.00501891C6.44911 0.0679793 4.26109 1.01011 2.63448 2.63769C1.00786 4.26527 0.066292 6.45459 0.00336896 8.75547C-0.059554 11.0564 0.760954 13.2939 2.29618 15.0081C3.83141 16.7222 5.96466 17.7827 8.25729 17.9714C10.5499 18.1601 12.8277 17.4626 14.6222 16.0225L18.3 19.7025C18.3929 19.7963 18.5035 19.8707 18.6253 19.9214C18.747 19.9722 18.8777 19.9983 19.0096 19.9983C19.1415 19.9983 19.2722 19.9722 19.3939 19.9214C19.5157 19.8707 19.6263 19.7963 19.7192 19.7025C19.8993 19.5161 20 19.2669 20 19.0075C20 18.7482 19.8993 18.499 19.7192 18.3125ZM9.01554 16.0225C7.63189 16.0225 6.27932 15.612 5.12886 14.8428C3.9784 14.0737 3.08172 12.9804 2.55223 11.7013C2.02273 10.4223 1.88419 9.01478 2.15412 7.65692C2.42406 6.29905 3.09035 5.05177 4.06873 4.0728C5.04712 3.09383 6.29366 2.42715 7.65072 2.15705C9.00778 1.88695 10.4144 2.02558 11.6927 2.55539C12.9711 3.08521 14.0637 3.98241 14.8324 5.13356C15.6011 6.2847 16.0114 7.63808 16.0114 9.02255C16.0114 10.8791 15.2743 12.6595 13.9623 13.9723C12.6504 15.2851 10.871 16.0225 9.01554 16.0225Z"
        fill="#7C7C8D"
      />
    </svg>
  );
}

export function NotificationIcon(props) {
  return (
    <svg
      width="20"
      height="24"
      viewBox="0 0 20 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.8 13.449V9.62358C16.7983 7.91915 16.1949 6.27032 15.0967 4.9691C13.9986 3.66788 12.4765 2.79823 10.8 2.51416V1.20295C10.8 0.883906 10.6736 0.577931 10.4485 0.352335C10.2235 0.126739 9.91826 0 9.6 0C9.28174 0 8.97651 0.126739 8.75147 0.352335C8.52643 0.577931 8.4 0.883906 8.4 1.20295V2.51416C6.72353 2.79823 5.20143 3.66788 4.10326 4.9691C3.0051 6.27032 2.40172 7.91915 2.4 9.62358V13.449C1.69974 13.6971 1.0932 14.1564 0.663526 14.7637C0.233854 15.371 0.00208741 16.0967 0 16.8413V19.2472C0 19.5662 0.126428 19.8722 0.351472 20.0978C0.576516 20.3234 0.88174 20.4501 1.2 20.4501H4.968C5.24434 21.4694 5.8476 22.3693 6.68471 23.0109C7.52183 23.6524 8.54627 24 9.6 24C10.6537 24 11.6782 23.6524 12.5153 23.0109C13.3524 22.3693 13.9557 21.4694 14.232 20.4501H18C18.3183 20.4501 18.6235 20.3234 18.8485 20.0978C19.0736 19.8722 19.2 19.5662 19.2 19.2472V16.8413C19.1979 16.0967 18.9661 15.371 18.5365 14.7637C18.1068 14.1564 17.5003 13.6971 16.8 13.449V13.449ZM4.8 9.62358C4.8 8.34741 5.30571 7.12351 6.20589 6.22113C7.10606 5.31874 8.32696 4.81179 9.6 4.81179C10.873 4.81179 12.0939 5.31874 12.9941 6.22113C13.8943 7.12351 14.4 8.34741 14.4 9.62358V13.2324H4.8V9.62358ZM9.6 21.6531C9.18117 21.6505 8.77029 21.5381 8.4082 21.3271C8.04611 21.1161 7.74541 20.8137 7.536 20.4501H11.664C11.4546 20.8137 11.1539 21.1161 10.7918 21.3271C10.4297 21.5381 10.0188 21.6505 9.6 21.6531ZM16.8 18.0442H2.4V16.8413C2.4 16.5222 2.52643 16.2162 2.75147 15.9906C2.97652 15.7651 3.28174 15.6383 3.6 15.6383H15.6C15.9183 15.6383 16.2235 15.7651 16.4485 15.9906C16.6736 16.2162 16.8 16.5222 16.8 16.8413V18.0442Z"
        fill="#72767C"
      />
      <circle
        cx="14.5"
        cy="6.5"
        r="3.75"
        fill="#FF5E6F"
        stroke="white"
        strokeWidth="1.5"
      />
    </svg>
  );
}

export function AddIcon(props) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 1V15"
        stroke="#FFFAF7"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 8H15"
        stroke="#FFFAF7"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function BackArrow(props) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 8H1"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 15L1 8L8 1"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function GmailIcon() {
  return (
    <svg
      width="20"
      height="12"
      viewBox="0 0 20 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.72729 0H17.2726C18.7789 0 19.9999 1.26605 19.9999 2.82781V3.22816C20 3.23805 20 3.24795 19.9999 3.25783V13.1964C19.9999 14.7582 18.7789 16.0242 17.2726 16.0242H2.72729C1.22108 16.0242 4.34265e-05 14.7582 4.34265e-05 13.1964V3.25222C-1.44492e-05 3.24607 -1.45017e-05 3.23992 4.34265e-05 3.23377V2.82781C4.34265e-05 1.26605 1.22108 0 2.72729 0ZM1.8184 5.05434V13.1965C1.8184 13.7171 2.22541 14.1391 2.72749 14.1391H17.2728C17.7749 14.1391 18.1819 13.7171 18.1819 13.1965V5.05412L11.564 9.85748C10.6249 10.539 9.37507 10.539 8.43602 9.85748L1.8184 5.05434ZM18.1792 2.75488L10.5213 8.31306C10.2083 8.54025 9.79169 8.54025 9.47867 8.31306L1.82107 2.7551C1.8569 2.26852 2.24903 1.88527 2.72749 1.88527H17.2728C17.7512 1.88527 18.1433 2.2684 18.1792 2.75488Z"
        fill="#777E90"
      />
    </svg>
  );
}

export function MobileIcon(props) {
  return (
    <svg
      width="22"
      height="12"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 15.92V18.92C21.0011 19.1985 20.9441 19.4742 20.8325 19.7294C20.7209 19.9845 20.5573 20.2136 20.3521 20.4019C20.1468 20.5901 19.9046 20.7335 19.6407 20.8227C19.3769 20.9119 19.0974 20.9451 18.82 20.92C15.7428 20.5856 12.787 19.5342 10.19 17.85C7.77382 16.3147 5.72533 14.2662 4.18999 11.85C2.49997 9.24121 1.44824 6.271 1.11999 3.18001C1.095 2.90347 1.12787 2.62477 1.21649 2.36163C1.30512 2.09849 1.44756 1.85669 1.63476 1.65163C1.82196 1.44656 2.0498 1.28271 2.30379 1.17053C2.55777 1.05834 2.83233 1.00027 3.10999 1.00001H6.10999C6.5953 0.995229 7.06579 1.16708 7.43376 1.48354C7.80173 1.79999 8.04207 2.23945 8.10999 2.72001C8.23662 3.68007 8.47144 4.62273 8.80999 5.53001C8.94454 5.88793 8.97366 6.27692 8.8939 6.65089C8.81415 7.02485 8.62886 7.36812 8.35999 7.64001L7.08999 8.91001C8.51355 11.4136 10.5864 13.4865 13.09 14.91L14.36 13.64C14.6319 13.3711 14.9751 13.1859 15.3491 13.1061C15.7231 13.0263 16.1121 13.0555 16.47 13.19C17.3773 13.5286 18.3199 13.7634 19.28 13.89C19.7658 13.9585 20.2094 14.2032 20.5265 14.5775C20.8437 14.9518 21.0122 15.4296 21 15.92Z"
        stroke={props.error ? "red" : "#777E90"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function StarIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.48015 1.499C9.52244 1.39583 9.59447 1.30758 9.68707 1.24546C9.77967 1.18334 9.88865 1.15018 10.0002 1.15018C10.1117 1.15018 10.2206 1.18334 10.3132 1.24546C10.4058 1.30758 10.4779 1.39583 10.5202 1.499L12.6452 6.61C12.6849 6.70564 12.7503 6.78844 12.8341 6.84931C12.9179 6.91018 13.0169 6.94675 13.1202 6.955L18.6382 7.397C19.1372 7.437 19.3392 8.06 18.9592 8.385L14.7551 11.987C14.6766 12.0542 14.6181 12.1417 14.586 12.24C14.5539 12.3382 14.5494 12.4434 14.5732 12.544L15.8582 17.929C15.884 18.037 15.8772 18.1503 15.8387 18.2545C15.8002 18.3587 15.7317 18.4491 15.6418 18.5144C15.5519 18.5797 15.4447 18.6169 15.3337 18.6212C15.2227 18.6256 15.1129 18.597 15.0182 18.539L10.2932 15.654C10.2049 15.6002 10.1035 15.5717 10.0002 15.5717C9.89679 15.5717 9.79541 15.6002 9.70715 15.654L4.98215 18.54C4.88741 18.598 4.7776 18.6266 4.66661 18.6222C4.55561 18.6179 4.4484 18.5807 4.35852 18.5154C4.26864 18.4501 4.20011 18.3597 4.1616 18.2555C4.12309 18.1513 4.11632 18.038 4.14215 17.93L5.42715 12.544C5.45098 12.4434 5.4466 12.3382 5.41449 12.2399C5.38238 12.1416 5.32379 12.0541 5.24515 11.987L1.04115 8.385C0.956964 8.31261 0.896061 8.21695 0.8661 8.11004C0.836139 8.00313 0.838459 7.88974 0.872767 7.78415C0.907075 7.67855 0.971839 7.58546 1.05892 7.51657C1.14599 7.44769 1.25149 7.40609 1.36215 7.397L6.88015 6.955C6.9834 6.94675 7.08237 6.91018 7.16618 6.84931C7.24998 6.78844 7.31537 6.70564 7.35515 6.61L9.48015 1.499Z"
        stroke="#4285F4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CloseIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 6L18 18"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 6L6 18"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function EyeIcon(props) {
  return (
    <svg
      width="20"
      height="17"
      viewBox="0 0 20 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.9165 8.1C17.8972 3.41 14.0986 0.5 10 0.5C5.90143 0.5 2.10275 3.41 0.0834557 8.1C0.0284116 8.22617 0 8.36234 0 8.5C0 8.63766 0.0284116 8.77383 0.0834557 8.9C2.10275 13.59 5.90143 16.5 10 16.5C14.0986 16.5 17.8972 13.59 19.9165 8.9C19.9716 8.77383 20 8.63766 20 8.5C20 8.36234 19.9716 8.22617 19.9165 8.1ZM10 14.5C6.8311 14.5 3.83215 12.21 2.10275 8.5C3.83215 4.79 6.8311 2.5 10 2.5C13.1689 2.5 16.1679 4.79 17.8972 8.5C16.1679 12.21 13.1689 14.5 10 14.5ZM10 4.5C9.20915 4.5 8.43606 4.7346 7.77849 5.17412C7.12093 5.61365 6.60841 6.23836 6.30577 6.96927C6.00312 7.70017 5.92394 8.50444 6.07823 9.28036C6.23251 10.0563 6.61334 10.769 7.17256 11.3284C7.73177 11.8878 8.44426 12.2688 9.21991 12.4231C9.99556 12.5775 10.7996 12.4983 11.5302 12.1955C12.2609 11.8928 12.8853 11.3801 13.3247 10.7223C13.7641 10.0645 13.9986 9.29113 13.9986 8.5C13.9986 7.43913 13.5773 6.42172 12.8274 5.67157C12.0776 4.92143 11.0605 4.5 10 4.5ZM10 10.5C9.60458 10.5 9.21803 10.3827 8.88925 10.1629C8.56046 9.94318 8.30421 9.63082 8.15288 9.26537C8.00156 8.89991 7.96197 8.49778 8.03911 8.10982C8.11626 7.72186 8.30667 7.36549 8.58628 7.08579C8.86589 6.80608 9.22213 6.6156 9.60996 6.53843C9.99778 6.46126 10.3998 6.50087 10.7651 6.65224C11.1304 6.80362 11.4427 7.05996 11.6624 7.38886C11.882 7.71776 11.9993 8.10444 11.9993 8.5C11.9993 9.03043 11.7887 9.53914 11.4137 9.91421C11.0388 10.2893 10.5302 10.5 10 10.5Z"
        fill={props.error ? "red" : "#777E91"}
      />
    </svg>
  );
}

export function HideEyeIcon(props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.60623 6.08071C1.72698 6.02901 1.85673 6.00161 1.98807 6.00007C2.11941 5.99853 2.24976 6.02287 2.37169 6.07172C2.49362 6.12056 2.60473 6.19295 2.69868 6.28475C2.79263 6.37654 2.86757 6.48595 2.91923 6.60671L2.00023 7.00071L2.92023 6.60671L2.92323 6.61471L2.94423 6.65971C2.96423 6.70171 2.99523 6.76771 3.03823 6.85371C3.12423 7.02571 3.25723 7.27771 3.43823 7.58271C3.91531 8.38461 4.47503 9.13436 5.10823 9.81971C5.29794 10.0239 5.49473 10.2213 5.69823 10.4117C7.18023 11.8007 9.25123 13.0007 12.0002 13.0007C13.102 13.0056 14.1947 12.8013 15.2202 12.3987C16.4472 11.9157 17.4742 11.1887 18.3162 10.4007C19.4415 9.33143 20.367 8.07001 21.0492 6.67571L21.0762 6.61771L21.0812 6.60671C21.1882 6.36672 21.3853 6.17847 21.63 6.08266C21.8746 5.98685 22.1472 5.99118 22.3887 6.09471C22.6301 6.19825 22.8212 6.39267 22.9205 6.63593C23.0198 6.8792 23.0193 7.15177 22.9192 7.39471L22.9172 7.39971L22.9132 7.40771L22.9022 7.43371L22.8622 7.52071C22.64 7.98324 22.3927 8.43325 22.1212 8.86871C21.6215 9.67176 21.0488 10.427 20.4102 11.1247L21.2072 11.9217C21.3949 12.1092 21.5003 12.3636 21.5004 12.6289C21.5005 12.8941 21.3952 13.1486 21.2077 13.3362C21.0202 13.5239 20.7659 13.6293 20.5006 13.6294C20.2353 13.6295 19.9809 13.5242 19.7932 13.3367L18.9532 12.4967C18.3628 12.9755 17.7275 13.3961 17.0562 13.7527L17.8382 14.9547C17.912 15.0647 17.9632 15.1883 17.9888 15.3183C18.0144 15.4483 18.0139 15.582 17.9874 15.7118C17.9609 15.8416 17.9089 15.9648 17.8343 16.0743C17.7598 16.1838 17.6642 16.2774 17.5532 16.3497C17.4422 16.422 17.3179 16.4715 17.1876 16.4953C17.0573 16.5191 16.9236 16.5169 16.7942 16.4886C16.6647 16.4603 16.5422 16.4066 16.4338 16.3306C16.3253 16.2545 16.233 16.1577 16.1622 16.0457L15.1762 14.5317C14.4972 14.7397 13.7722 14.8867 13.0002 14.9557V16.5007C13.0002 16.7659 12.8949 17.0203 12.7073 17.2078C12.5198 17.3954 12.2654 17.5007 12.0002 17.5007C11.735 17.5007 11.4807 17.3954 11.2931 17.2078C11.1056 17.0203 11.0002 16.7659 11.0002 16.5007V14.9567C10.2252 14.8867 9.50023 14.7397 8.82323 14.5317L7.83823 16.0457C7.69033 16.2602 7.46457 16.4085 7.20898 16.459C6.9534 16.5096 6.68818 16.4584 6.46977 16.3164C6.25136 16.1743 6.09701 15.9526 6.03958 15.6985C5.98214 15.4444 6.02614 15.1779 6.16223 14.9557L6.94423 13.7527C6.24423 13.3827 5.61223 12.9527 5.04723 12.4957L4.20723 13.3357C4.01863 13.5179 3.76602 13.6187 3.50383 13.6164C3.24163 13.6141 2.99082 13.5089 2.80541 13.3235C2.62 13.1381 2.51483 12.8873 2.51256 12.6251C2.51028 12.3629 2.61107 12.1103 2.79323 11.9217L3.59023 11.1247C2.8828 10.3509 2.25622 9.50682 1.72023 8.60571C1.50612 8.2461 1.30891 7.8767 1.12923 7.49871C1.11805 7.47479 1.10705 7.45079 1.09623 7.42671L1.08623 7.40571L1.08423 7.39871L1.08323 7.39671C1.08023 7.39671 1.08023 7.39471 2.00023 7.00071L1.08123 7.39571C1.02935 7.27497 1.00177 7.14519 1.00008 7.01378C0.998392 6.88238 1.02262 6.75193 1.07138 6.6299C1.12014 6.50786 1.19247 6.39663 1.28424 6.30257C1.37602 6.20851 1.48543 6.13246 1.60623 6.08071Z"
        fill={props.error ? "red" : "#777E91"}
      />
    </svg>
  );
}

export function TooltipIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99984 18.3333C14.6022 18.3333 18.3332 14.6024 18.3332 10C18.3332 5.39763 14.6022 1.66667 9.99984 1.66667C5.39746 1.66667 1.6665 5.39763 1.6665 10C1.6665 14.6024 5.39746 18.3333 9.99984 18.3333Z"
        stroke="#5F6165"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 13.3333V10"
        stroke="#5F6165"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 6.66667H10.01"
        stroke="#5F6165"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export const GoogleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      zoomAndPan="magnify"
      viewBox="0 0 30 30.000001"
      height="30"
      preserveAspectRatio="xMidYMid meet"
      version="1.0"
      style={{ verticalAlign: "middle" }}
    >
      <path
        fill="#4280ef"
        d="M 23.964844 14.769531 C 23.964844 14.15625 23.902344 13.519531 23.804688 12.925781 L 15.214844 12.925781 L 15.214844 16.4375 L 20.136719 16.4375 C 19.9375 17.566406 19.28125 18.558594 18.308594 19.195312 L 21.246094 21.476562 C 22.972656 19.871094 23.964844 17.527344 23.964844 14.769531 Z M 23.964844 14.769531 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#34a353"
        d="M 15.214844 23.660156 C 17.675781 23.660156 19.738281 22.84375 21.246094 21.457031 L 18.308594 19.195312 C 17.496094 19.75 16.445312 20.066406 15.214844 20.066406 C 12.835938 20.066406 10.832031 18.460938 10.097656 16.316406 L 7.082031 18.640625 C 8.628906 21.714844 11.761719 23.660156 15.214844 23.660156 Z M 15.214844 23.660156 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#f6b704"
        d="M 10.097656 16.296875 C 9.71875 15.167969 9.71875 13.9375 10.097656 12.804688 L 7.082031 10.464844 C 5.792969 13.042969 5.792969 16.078125 7.082031 18.640625 Z M 10.097656 16.296875 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#e54335"
        d="M 15.214844 9.058594 C 16.503906 9.039062 17.773438 9.535156 18.707031 10.425781 L 21.304688 7.808594 C 19.660156 6.261719 17.476562 5.425781 15.214844 5.445312 C 11.761719 5.445312 8.628906 7.390625 7.082031 10.464844 L 10.097656 12.804688 C 10.832031 10.644531 12.835938 9.058594 15.214844 9.058594 Z M 15.214844 9.058594 "
        fillOpacity="1"
        fillRule="nonzero"
      />
    </svg>
  );
};

export const ExerciseIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.3125 6L8.27743 6.03564L8.27714 6.03536L8.3125 6ZM8.3125 6L8.27714 5.96464L8.27686 5.96493L8.3125 6ZM16.173 6.84785L16.2078 6.88263L16.8188 7.49369C17.1286 7.80345 17.2833 8.18283 17.2833 8.635C17.2833 9.08717 17.1286 9.46684 16.8188 9.77717L15.6313 10.9646C15.3217 11.2742 14.9388 11.4292 14.4792 11.4292C14.0196 11.4292 13.6367 11.2743 13.3271 10.9647C13.3271 10.9647 13.3271 10.9647 13.327 10.9646L12.0356 9.65243L12.0003 9.6165L11.9646 9.65214L9.67298 11.9438L9.63762 11.9792L9.67298 12.0145L10.9855 13.327C11.2952 13.6368 11.45 14.0164 11.45 14.4692C11.45 14.9219 11.2952 15.3013 10.9855 15.6104L10.9855 15.6105L9.79798 16.798C9.48837 17.1076 9.10546 17.2625 8.64583 17.2625C8.1862 17.2625 7.80329 17.1076 7.49369 16.798L6.90404 16.2083L6.86869 16.173L5.68119 14.9855L5.64525 14.9495L3.05046 12.3547L3.01452 12.3188L1.82702 11.1313L1.79167 11.096L1.20202 10.5063C0.892417 10.1967 0.7375 9.8138 0.7375 9.35417C0.7375 8.89454 0.892417 8.51163 1.20202 8.20202L2.38952 7.01452C2.69929 6.70476 3.07866 6.55 3.53083 6.55C3.98301 6.55 4.36268 6.70476 4.67301 7.01455L5.98548 8.32702L6.02083 8.36238L6.05619 8.32702L8.34786 6.03535L8.38349 5.99971L8.34757 5.96436L7.03536 4.67298C7.03531 4.67293 7.03527 4.67289 7.03522 4.67284C6.72571 4.36326 6.57083 3.9804 6.57083 3.52083C6.57083 3.0612 6.72575 2.67829 7.03536 2.36869L8.22286 1.18119C8.53261 0.871436 8.91225 0.716666 9.365 0.716666C9.81775 0.716666 10.1971 0.871434 10.5063 1.18116L10.5063 1.18119L11.0965 1.77141L11.1313 1.80619L12.3188 2.99369L12.3536 3.02847L14.9715 5.64641L15.0063 5.68119L16.173 6.84785ZM5.64642 15.0921L6.76262 16.2083L6.17298 16.798C5.86323 17.1077 5.48358 17.2625 5.03083 17.2625C4.57809 17.2625 4.19903 17.1077 3.89042 16.798L3.89035 16.798L1.20202 14.1105C1.20202 14.1105 1.20202 14.1105 1.20202 14.1105C0.892268 13.8007 0.7375 13.4211 0.7375 12.9683C0.7375 12.5156 0.892267 12.1362 1.20199 11.8271L1.20202 11.827L1.79167 11.2374L2.90787 12.3536L2.29856 12.9432L2.26204 12.9786L2.29798 13.0145L4.98548 15.702L5.02142 15.738L5.05676 15.7014L5.64642 15.0921ZM17.2833 5.01C17.2833 5.46204 17.1287 5.84162 16.8191 6.1519C16.819 6.15199 16.8189 6.15208 16.8188 6.15217L16.2089 6.74236L15.1118 5.64526L15.7026 5.03477L15.7368 4.99942L15.702 4.96464L13.0354 2.29798L13.0006 2.2632L12.9652 2.2974L12.3547 2.8882L11.2368 1.77026L11.827 1.16035C11.8271 1.16027 11.8272 1.16018 11.8273 1.16009C12.1367 0.850847 12.5192 0.699344 12.9785 0.705828C13.4383 0.712319 13.8215 0.870825 14.1313 1.18116L14.1313 1.18119L16.8188 3.86869C17.1286 4.17845 17.2833 4.55783 17.2833 5.01ZM14.4438 9.86869L14.4792 9.90404L14.5145 9.86869L15.702 8.68119L15.7374 8.64583L15.702 8.61048L9.38952 2.29798L9.35417 2.26262L9.31881 2.29798L8.13131 3.48548L8.09596 3.52083L8.13131 3.55619L14.4438 9.86869ZM8.61048 15.702L8.64614 15.7377L8.68149 15.7017L9.869 14.4934L9.90374 14.458L9.86869 14.423L3.57702 8.13131L3.54197 8.09626L3.50662 8.131L2.29829 9.3185L2.26231 9.35386L2.29798 9.38952L8.61048 15.702ZM8.48548 10.827L8.52067 10.8622L8.55603 10.8272L10.8477 8.55635L10.8834 8.52099L10.8479 8.48548L9.51452 7.15214L9.479 7.11663L9.44365 7.15231L7.17282 9.44397L7.13778 9.47933L7.17298 9.51452L8.48548 10.827Z"
        fill={props.color}
        stroke="#FCE8E4"
        strokeWidth="0.1"
      />
    </svg>
  );
};

export const MedicationIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.21668 17.8233H5.00001C4.21418 17.8233 3.82168 17.8233 3.57751 17.5792C3.33334 17.3358 3.33334 16.9433 3.33334 16.1575V15.2308C3.33334 14.7992 3.33334 14.5833 3.44418 14.39C3.55501 14.1975 3.72251 14.1 4.05751 13.905C6.26251 12.6225 9.39251 11.9008 11.4825 13.1467C11.6225 13.2308 11.7492 13.3325 11.8575 13.4533C11.9694 13.576 12.0556 13.7198 12.1111 13.8763C12.1665 14.0329 12.19 14.1989 12.1802 14.3646C12.1704 14.5304 12.1275 14.6925 12.0541 14.8414C11.9806 14.9903 11.8781 15.123 11.7525 15.2317C11.6524 15.3269 11.5301 15.3956 11.3967 15.4317C11.4967 15.42 11.5925 15.4067 11.6842 15.3925C12.4433 15.2717 13.0808 14.865 13.6642 14.4242L15.1708 13.2867C15.4396 13.0911 15.7635 12.9858 16.0958 12.9858C16.4282 12.9858 16.7521 13.0911 17.0208 13.2867C17.4983 13.6475 17.645 14.2417 17.3425 14.7267C16.99 15.2917 16.4933 16.0142 16.0167 16.4558C15.5392 16.8975 14.8283 17.2925 14.2483 17.5725C13.605 17.8833 12.895 18.0617 12.1725 18.1792C10.7075 18.4158 9.18084 18.3792 7.73084 18.0808C6.90358 17.9107 6.06124 17.8239 5.21668 17.8233ZM9.46668 7.67C9.89437 8.08105 10.4662 8.30799 11.0594 8.30207C11.6526 8.29614 12.2198 8.05784 12.6392 7.63832C13.0586 7.21881 13.2967 6.65155 13.3025 6.05838C13.3083 5.4652 13.0812 4.89342 12.67 4.46583L12.0667 3.86333C11.8167 4.3675 11.3975 5.025 10.7108 5.71166C10.025 6.3975 9.36751 6.81666 8.86334 7.06666L9.46668 7.67ZM10.5333 2.33C10.1056 1.91894 9.53381 1.69201 8.94063 1.69793C8.34746 1.70385 7.78026 1.94216 7.36086 2.36167C6.94146 2.78118 6.70329 3.34844 6.69753 3.94162C6.69176 4.53479 6.91884 5.10657 7.33001 5.53416L8.23501 6.43916C8.30369 6.41002 8.37176 6.37946 8.43918 6.3475C8.87501 6.13666 9.47918 5.76416 10.1225 5.1225C10.7642 4.47916 11.1367 3.875 11.3475 3.43916C11.3797 3.37185 11.4103 3.30377 11.4392 3.235L10.5333 2.33Z"
        fill={props.color}
      />
    </svg>
  );
};

export const PlayIcon = (props) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill="#686868" fillOpacity="0.5" />
      <path
        d="M20.7 32.0333C20.2556 32.3222 19.8058 32.3391 19.3507 32.084C18.8956 31.8288 18.6676 31.4342 18.6667 30.9V17.1C18.6667 16.5666 18.8947 16.172 19.3507 15.916C19.8067 15.66 20.2564 15.6768 20.7 15.9666L31.5667 22.8666C31.9667 23.1333 32.1667 23.5111 32.1667 24C32.1667 24.4888 31.9667 24.8666 31.5667 25.1333L20.7 32.0333ZM21.3333 28.4666L28.3333 24L21.3333 19.5333V28.4666Z"
        fill="white"
      />
    </svg>
  );
};

export const ExerciseEditIcon = (props) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill="#686868" fillOpacity="0.5" />
      <path
        d="M17 34.7C16.45 34.7 15.979 34.5044 15.587 34.113C15.195 33.7217 14.9993 33.2507 15 32.7V18.7C15 18.15 15.196 17.679 15.588 17.287C15.98 16.895 16.4507 16.6994 17 16.7H25.925L23.925 18.7H17V32.7H31V25.75L33 23.75V32.7C33 33.25 32.804 33.721 32.412 34.113C32.02 34.505 31.5493 34.7007 31 34.7H17ZM28.175 17.275L29.6 18.675L23 25.275V26.7H24.4L31.025 20.075L32.45 21.475L25.825 28.1C25.6417 28.2834 25.429 28.4294 25.187 28.538C24.945 28.6467 24.691 28.7007 24.425 28.7H22C21.7167 28.7 21.479 28.604 21.287 28.412C21.095 28.22 20.9993 27.9827 21 27.7V25.275C21 25.0084 21.05 24.754 21.15 24.512C21.25 24.27 21.3917 24.0577 21.575 23.875L28.175 17.275ZM32.45 21.475L28.175 17.275L30.675 14.775C31.075 14.375 31.5543 14.175 32.113 14.175C32.6717 14.175 33.1423 14.375 33.525 14.775L34.925 16.2C35.3083 16.5834 35.5 17.05 35.5 17.6C35.5 18.15 35.3083 18.6167 34.925 19L32.45 21.475Z"
        fill="white"
      />
    </svg>
  );
};

export const ExerciseDeleteIcon = (props) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill="#686868" fillOpacity="0.5" />
      <path
        d="M19 33C18.45 33 17.979 32.804 17.587 32.412C17.195 32.02 16.9993 31.5493 17 31V18C16.7167 18 16.479 17.904 16.287 17.712C16.095 17.52 15.9993 17.2827 16 17C16 16.7167 16.096 16.479 16.288 16.287C16.48 16.095 16.7173 15.9993 17 16H21C21 15.7167 21.096 15.479 21.288 15.287C21.48 15.095 21.7173 14.9993 22 15H26C26.2833 15 26.521 15.096 26.713 15.288C26.905 15.48 27.0007 15.7173 27 16H31C31.2833 16 31.521 16.096 31.713 16.288C31.905 16.48 32.0007 16.7173 32 17C32 17.2833 31.904 17.521 31.712 17.713C31.52 17.905 31.2827 18.0007 31 18V31C31 31.55 30.804 32.021 30.412 32.413C30.02 32.805 29.5493 33.0007 29 33H19ZM19 18V31H29V18H19ZM21 28C21 28.2833 21.096 28.521 21.288 28.713C21.48 28.905 21.7173 29.0007 22 29C22.2833 29 22.521 28.904 22.713 28.712C22.905 28.52 23.0007 28.2827 23 28V21C23 20.7167 22.904 20.479 22.712 20.287C22.52 20.095 22.2827 19.9993 22 20C21.7167 20 21.479 20.096 21.287 20.288C21.095 20.48 20.9993 20.7173 21 21V28ZM25 28C25 28.2833 25.096 28.521 25.288 28.713C25.48 28.905 25.7173 29.0007 26 29C26.2833 29 26.521 28.904 26.713 28.712C26.905 28.52 27.0007 28.2827 27 28V21C27 20.7167 26.904 20.479 26.712 20.287C26.52 20.095 26.2827 19.9993 26 20C25.7167 20 25.479 20.096 25.287 20.288C25.095 20.48 24.9993 20.7173 25 21V28Z"
        fill="#E24020"
      />
    </svg>
  );
};

export const FloatingButtonAddIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 14C6.71667 14 6.479 13.904 6.287 13.712C6.095 13.52 5.99934 13.2827 6 13V8H1C0.71667 8 0.479004 7.904 0.287004 7.712C0.0950036 7.52 -0.000663206 7.28267 3.4602e-06 7C3.4602e-06 6.71667 0.0960036 6.479 0.288004 6.287C0.480004 6.095 0.717337 5.99934 1 6H6V1C6 0.71667 6.096 0.479004 6.288 0.287004C6.48 0.0950036 6.71734 -0.000663206 7 3.4602e-06C7.28334 3.4602e-06 7.521 0.0960036 7.713 0.288004C7.905 0.480004 8.00067 0.717337 8 1V6H13C13.2833 6 13.521 6.096 13.713 6.288C13.905 6.48 14.0007 6.71734 14 7C14 7.28334 13.904 7.521 13.712 7.713C13.52 7.905 13.2827 8.00067 13 8H8V13C8 13.2833 7.904 13.521 7.712 13.713C7.52 13.905 7.28267 14.0007 7 14Z"
        fill="white"
      />
    </svg>
  );
};

export const UploadIcon = () => {
  return (
    <svg
      width="78"
      height="64"
      viewBox="0 0 78 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M52.3334 45.3333L39.0001 32L25.6667 45.3333"
        stroke="#E24020"
        strokeWidth="3.84615"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39 32V62"
        stroke="#E24020"
        strokeWidth="3.84615"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M66.9668 53.2996C70.2179 51.5272 72.7862 48.7226 74.2664 45.3284C75.7465 41.9342 76.0542 38.1437 75.1408 34.5553C74.2274 30.9668 72.1451 27.7847 69.2223 25.5111C66.2996 23.2376 62.703 22.0021 59.0001 21.9996H54.8001C53.7912 18.0971 51.9106 14.4741 49.2999 11.4029C46.6892 8.33179 43.4163 5.89245 39.7271 4.26831C36.038 2.64417 32.0286 1.87748 28.0005 2.0259C23.9724 2.17431 20.0303 3.23395 16.4707 5.12517C12.9111 7.01639 9.82648 9.68996 7.44885 12.9449C5.07122 16.1998 3.46241 19.9514 2.74338 23.9176C2.02434 27.8838 2.2138 31.9614 3.29749 35.8438C4.38118 39.7263 6.33092 43.3125 9.00011 46.3329"
        stroke="#E24020"
        strokeWidth="3.84615"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M52.3334 45.3333L39.0001 32L25.6667 45.3333"
        stroke="#E24020"
        strokeWidth="3.84615"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const VideoPlayerCloseIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4998 13.2341L17.3357 20.0713C17.6984 20.434 18.1904 20.6378 18.7034 20.6378C19.2164 20.6378 19.7083 20.434 20.0711 20.0713C20.4338 19.7086 20.6376 19.2166 20.6376 18.7036C20.6376 18.1906 20.4338 17.6986 20.0711 17.3359L13.2326 10.5L20.0698 3.6641C20.2493 3.4845 20.3917 3.27129 20.4888 3.03665C20.586 2.80201 20.6359 2.55054 20.6359 2.2966C20.6358 2.04265 20.5857 1.79121 20.4885 1.55661C20.3912 1.32202 20.2488 1.10888 20.0691 0.929357C19.8895 0.749833 19.6763 0.607444 19.4417 0.510318C19.2071 0.413193 18.9556 0.363234 18.7016 0.363294C18.4477 0.363354 18.1962 0.413431 17.9617 0.510667C17.7271 0.607903 17.5139 0.750393 17.3344 0.930001L10.4998 7.7659L3.6639 0.930001C3.48561 0.745241 3.27232 0.597837 3.03646 0.496389C2.80061 0.394942 2.54691 0.341483 2.29017 0.339131C2.03343 0.33678 1.77879 0.385584 1.54112 0.482694C1.30344 0.579805 1.08748 0.723279 0.905848 0.904743C0.724213 1.08621 0.580536 1.30203 0.483202 1.53961C0.385867 1.7772 0.336823 2.03179 0.338932 2.28853C0.341042 2.54527 0.394261 2.79902 0.495486 3.03497C0.596711 3.27093 0.743914 3.48436 0.928506 3.66282L7.76698 10.5L0.929795 17.3359C0.56706 17.6986 0.363277 18.1906 0.363277 18.7036C0.363277 19.2166 0.56706 19.7086 0.929795 20.0713C1.29253 20.434 1.7845 20.6378 2.29749 20.6378C2.81048 20.6378 3.30245 20.434 3.66518 20.0713L10.4998 13.2328V13.2341Z"
        fill="white"
      />
    </svg>
  );
};

export const SuccessIcon = () => {
  return (
    <svg
      width="54"
      height="54"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginBottom: "15px" }}
    >
      <path
        d="M53.8192 27.1524C53.8192 41.8791 41.8792 53.8191 27.1525 53.8191C12.4258 53.8191 0.48584 41.8791 0.48584 27.1524C0.48584 12.4257 12.4258 0.485718 27.1525 0.485718C41.8792 0.485718 53.8192 12.4257 53.8192 27.1524Z"
        fill="#EA5131"
      />
      <path
        d="M23.543 38.7617L12.8764 28.0951C12.355 27.5737 12.355 26.7297 12.8764 26.2097L14.7617 24.3244C15.283 23.8031 16.127 23.8031 16.647 24.3244L24.4857 32.163L38.991 17.6577C39.5123 17.1364 40.3563 17.1364 40.8763 17.6577L42.7617 19.5431C43.283 20.0644 43.283 20.9084 42.7617 21.4284L25.4283 38.7617C24.9083 39.283 24.063 39.283 23.543 38.7617Z"
        fill="url(#paint0_linear_2_1287)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2_1287"
          x1="12.4857"
          y1="28.2097"
          x2="43.1523"
          y2="28.2097"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.824" stopColor="white" />
          <stop offset="0.931" stopColor="white" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const RequiredStar = () => {
  return (
    <svg
      width="7"
      height="8"
      viewBox="0 0 7 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        display: "inline",
        marginLeft: "5px",
        marginBottom: "5px",
      }}
    >
      <path
        d="M4.382 0.751999H2.708L3.068 3.38L0.962 1.76L0.134 3.236L2.582 4.118L0.134 5.036L0.998 6.566L3.05 4.91L2.708 7.52H4.364L3.986 4.91L6.038 6.53L6.866 5.054L4.4 4.136L6.866 3.218L6.056 1.778L3.986 3.38L4.382 0.751999Z"
        fill="#E24020"
      />
    </svg>
  );
};

export const ExtractionSuccess = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      style={{ position: "relative", display: "flex" }}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="10" fill="#4F9E4E" />
      <path
        d="M8.36642 13.7166C8.27753 13.7166 8.1942 13.7026 8.11642 13.6746C8.03864 13.6466 7.96642 13.5995 7.89976 13.5333L5.03309 10.6666C4.91087 10.5444 4.85242 10.3859 4.85776 10.1913C4.86309 9.9966 4.92709 9.83838 5.04976 9.7166C5.17198 9.59438 5.32753 9.53327 5.51642 9.53327C5.70531 9.53327 5.86087 9.59438 5.98309 9.7166L8.36642 12.0999L14.0164 6.44993C14.1386 6.32771 14.2971 6.2666 14.4918 6.2666C14.6864 6.2666 14.8446 6.32771 14.9664 6.44993C15.0886 6.57216 15.1498 6.7306 15.1498 6.92527C15.1498 7.11993 15.0886 7.27816 14.9664 7.39994L8.83309 13.5333C8.76642 13.5999 8.6942 13.6473 8.61642 13.6753C8.53864 13.7033 8.45531 13.717 8.36642 13.7166Z"
        fill="white"
      />
    </svg>
  );
};

export const ExtractionFailed = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      style={{ position: "relative", display: "flex" }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="10" fill="#E53C35" />
      <path
        d="M9.99967 8.33333C9.77866 8.33333 9.5667 8.42113 9.41042 8.57741C9.25414 8.73369 9.16634 8.94565 9.16634 9.16667V14.1667C9.16634 14.3877 9.25414 14.5996 9.41042 14.7559C9.5667 14.9122 9.77866 15 9.99967 15C10.2207 15 10.4326 14.9122 10.5889 14.7559C10.7452 14.5996 10.833 14.3877 10.833 14.1667V9.16667C10.833 8.94565 10.7452 8.73369 10.5889 8.57741C10.4326 8.42113 10.2207 8.33333 9.99967 8.33333ZM9.99967 5C9.79365 5 9.59226 5.06109 9.42096 5.17555C9.24965 5.29001 9.11614 5.4527 9.0373 5.64304C8.95846 5.83338 8.93783 6.04282 8.97802 6.24489C9.01822 6.44695 9.11743 6.63256 9.26311 6.77824C9.40879 6.92392 9.59439 7.02313 9.79646 7.06332C9.99852 7.10351 10.208 7.08288 10.3983 7.00404C10.5886 6.9252 10.7513 6.79169 10.8658 6.62039C10.9802 6.44908 11.0413 6.24769 11.0413 6.04167C11.0413 5.7654 10.9316 5.50045 10.7362 5.3051C10.5409 5.10975 10.2759 5 9.99967 5Z"
        fill="white"
      />
    </svg>
  );
};

export const DeleteAdmin = (props) => {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.8335 15.5C2.37517 15.5 1.98267 15.3367 1.656 15.01C1.32933 14.6833 1.16628 14.2911 1.16683 13.8333V3C0.930721 3 0.732666 2.92 0.572666 2.76C0.412666 2.6 0.332943 2.40223 0.333499 2.16667C0.333499 1.93056 0.413499 1.7325 0.573499 1.5725C0.733499 1.4125 0.931277 1.33278 1.16683 1.33334H4.50017C4.50017 1.09723 4.58017 0.89917 4.74017 0.73917C4.90017 0.57917 5.09794 0.499447 5.3335 0.500003H8.66683C8.90294 0.500003 9.101 0.580003 9.261 0.740003C9.421 0.900003 9.50072 1.09778 9.50017 1.33334H12.8335C13.0696 1.33334 13.2677 1.41334 13.4277 1.57334C13.5877 1.73334 13.6674 1.93111 13.6668 2.16667C13.6668 2.40278 13.5868 2.60084 13.4268 2.76084C13.2668 2.92084 13.0691 3.00056 12.8335 3V13.8333C12.8335 14.2917 12.6702 14.6842 12.3435 15.0108C12.0168 15.3375 11.6246 15.5006 11.1668 15.5H2.8335ZM2.8335 3V13.8333H11.1668V3H2.8335ZM4.50017 11.3333C4.50017 11.5694 4.58017 11.7675 4.74017 11.9275C4.90017 12.0875 5.09794 12.1672 5.3335 12.1667C5.56961 12.1667 5.76767 12.0867 5.92767 11.9267C6.08767 11.7667 6.16739 11.5689 6.16683 11.3333V5.5C6.16683 5.26389 6.08683 5.06584 5.92683 4.90584C5.76683 4.74584 5.56905 4.66611 5.3335 4.66667C5.09739 4.66667 4.89933 4.74667 4.73933 4.90667C4.57933 5.06667 4.49961 5.26445 4.50017 5.5V11.3333ZM7.8335 11.3333C7.8335 11.5694 7.9135 11.7675 8.0735 11.9275C8.2335 12.0875 8.43128 12.1672 8.66683 12.1667C8.90294 12.1667 9.101 12.0867 9.261 11.9267C9.421 11.7667 9.50072 11.5689 9.50017 11.3333V5.5C9.50017 5.26389 9.42017 5.06584 9.26017 4.90584C9.10017 4.74584 8.90239 4.66611 8.66683 4.66667C8.43072 4.66667 8.23267 4.74667 8.07267 4.90667C7.91267 5.06667 7.83294 5.26445 7.8335 5.5V11.3333Z"
        fill="#E24020"
      />
    </svg>
  );
};

export const ImportIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 11.6667C17.279 11.6667 17.067 11.7545 16.9108 11.9107C16.7545 12.067 16.6667 12.279 16.6667 12.5V15.8333C16.6667 16.0543 16.5789 16.2663 16.4226 16.4226C16.2663 16.5789 16.0544 16.6667 15.8334 16.6667H4.16669C3.94567 16.6667 3.73371 16.5789 3.57743 16.4226C3.42115 16.2663 3.33335 16.0543 3.33335 15.8333V12.5C3.33335 12.279 3.24556 12.067 3.08928 11.9107C2.933 11.7545 2.72103 11.6667 2.50002 11.6667C2.27901 11.6667 2.06704 11.7545 1.91076 11.9107C1.75448 12.067 1.66669 12.279 1.66669 12.5V15.8333C1.66669 16.4964 1.93008 17.1323 2.39892 17.6011C2.86776 18.0699 3.50365 18.3333 4.16669 18.3333H15.8334C16.4964 18.3333 17.1323 18.0699 17.6011 17.6011C18.07 17.1323 18.3334 16.4964 18.3334 15.8333V12.5C18.3334 12.279 18.2456 12.067 18.0893 11.9107C17.933 11.7545 17.721 11.6667 17.5 11.6667ZM9.40835 13.0917C9.48761 13.1675 9.58106 13.227 9.68335 13.2667C9.7831 13.3108 9.89096 13.3335 10 13.3335C10.1091 13.3335 10.2169 13.3108 10.3167 13.2667C10.419 13.227 10.5124 13.1675 10.5917 13.0917L13.925 9.75833C14.0819 9.60141 14.1701 9.38858 14.1701 9.16666C14.1701 8.94475 14.0819 8.73192 13.925 8.575C13.7681 8.41808 13.5553 8.32992 13.3334 8.32992C13.1114 8.32992 12.8986 8.41808 12.7417 8.575L10.8334 10.4917V2.5C10.8334 2.27898 10.7456 2.06702 10.5893 1.91074C10.433 1.75446 10.221 1.66666 10 1.66666C9.77901 1.66666 9.56704 1.75446 9.41076 1.91074C9.25448 2.06702 9.16669 2.27898 9.16669 2.5V10.4917L7.25835 8.575C7.18065 8.4973 7.08841 8.43566 6.98689 8.39361C6.88538 8.35156 6.77657 8.32992 6.66669 8.32992C6.5568 8.32992 6.448 8.35156 6.34648 8.39361C6.24496 8.43566 6.15272 8.4973 6.07502 8.575C5.99732 8.6527 5.93569 8.74494 5.89364 8.84645C5.85159 8.94797 5.82994 9.05678 5.82994 9.16666C5.82994 9.27655 5.85159 9.38535 5.89364 9.48687C5.93569 9.58839 5.99732 9.68063 6.07502 9.75833L9.40835 13.0917Z"
        fill="#A5A5A5"
      />
    </svg>
  );
};

export const EditButtonIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.16667 19.75C3.70833 19.75 3.31583 19.5869 2.98917 19.2608C2.6625 18.9347 2.49945 18.5422 2.5 18.0833V6.41667C2.5 5.95833 2.66333 5.56584 2.99 5.23917C3.31667 4.9125 3.70889 4.74945 4.16667 4.75H11.6042L9.9375 6.41667H4.16667V18.0833H15.8333V12.2917L17.5 10.625V18.0833C17.5 18.5417 17.3367 18.9342 17.01 19.2608C16.6833 19.5875 16.2911 19.7506 15.8333 19.75H4.16667ZM13.4792 5.22917L14.6667 6.39583L9.16667 11.8958V13.0833H10.3333L15.8542 7.5625L17.0417 8.72917L11.5208 14.25C11.3681 14.4028 11.1908 14.5244 10.9892 14.615C10.7875 14.7056 10.5758 14.7506 10.3542 14.75H8.33334C8.09722 14.75 7.89917 14.67 7.73917 14.51C7.57917 14.35 7.49945 14.1522 7.5 13.9167V11.8958C7.5 11.6736 7.54167 11.4617 7.625 11.26C7.70834 11.0583 7.82639 10.8814 7.97917 10.7292L13.4792 5.22917ZM17.0417 8.72917L13.4792 5.22917L15.5625 3.14584C15.8958 2.8125 16.2953 2.64584 16.7608 2.64584C17.2264 2.64584 17.6186 2.8125 17.9375 3.14584L19.1042 4.33334C19.4236 4.65278 19.5833 5.04167 19.5833 5.5C19.5833 5.95834 19.4236 6.34722 19.1042 6.66667L17.0417 8.72917Z"
        fill={props.disabled ? "#dbdbdb" : "#E24020"}
      />
    </svg>
  );
};

export const DeleteButtonIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.83338 17.5C5.37504 17.5 4.98254 17.3367 4.65588 17.01C4.32921 16.6833 4.16615 16.2911 4.16671 15.8333V5C3.9306 5 3.73254 4.92 3.57254 4.76C3.41254 4.6 3.33282 4.40223 3.33338 4.16667C3.33338 3.93056 3.41338 3.7325 3.57338 3.5725C3.73338 3.4125 3.93115 3.33278 4.16671 3.33334H7.50004C7.50004 3.09723 7.58004 2.89917 7.74004 2.73917C7.90004 2.57917 8.09782 2.49945 8.33338 2.5H11.6667C11.9028 2.5 12.1009 2.58 12.2609 2.74C12.4209 2.9 12.5006 3.09778 12.5 3.33334H15.8334C16.0695 3.33334 16.2675 3.41334 16.4275 3.57334C16.5875 3.73334 16.6673 3.93111 16.6667 4.16667C16.6667 4.40278 16.5867 4.60084 16.4267 4.76084C16.2667 4.92084 16.0689 5.00056 15.8334 5V15.8333C15.8334 16.2917 15.67 16.6842 15.3434 17.0108C15.0167 17.3375 14.6245 17.5006 14.1667 17.5H5.83338ZM5.83338 5V15.8333H14.1667V5H5.83338ZM7.50004 13.3333C7.50004 13.5694 7.58004 13.7675 7.74004 13.9275C7.90004 14.0875 8.09782 14.1672 8.33338 14.1667C8.56949 14.1667 8.76754 14.0867 8.92754 13.9267C9.08754 13.7667 9.16727 13.5689 9.16671 13.3333V7.5C9.16671 7.26389 9.08671 7.06584 8.92671 6.90584C8.76671 6.74584 8.56893 6.66611 8.33338 6.66667C8.09727 6.66667 7.89921 6.74667 7.73921 6.90667C7.57921 7.06667 7.49949 7.26445 7.50004 7.5V13.3333ZM10.8334 13.3333C10.8334 13.5694 10.9134 13.7675 11.0734 13.9275C11.2334 14.0875 11.4312 14.1672 11.6667 14.1667C11.9028 14.1667 12.1009 14.0867 12.2609 13.9267C12.4209 13.7667 12.5006 13.5689 12.5 13.3333V7.5C12.5 7.26389 12.42 7.06584 12.26 6.90584C12.1 6.74584 11.9023 6.66611 11.6667 6.66667C11.4306 6.66667 11.2325 6.74667 11.0725 6.90667C10.9125 7.06667 10.8328 7.26445 10.8334 7.5V13.3333Z"
        fill="white"
      />
    </svg>
  );
};

export const CheckBoxIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_i_1_826)">
        <rect width="16" height="16" rx="2" fill="white" />
      </g>
      <defs>
        <filter
          id="filter0_i_1_826"
          x="0"
          y="0"
          width="16"
          height="16"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_1_826"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const SortIcon = () => {
  return (
    <svg
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4 0L7.4641 6H0.535898L4 0Z" fill="#808080" />
      <path d="M4 14L7.4641 8H0.535898L4 14Z" fill="#808080" />
    </svg>
  );
};

export const BulkExerciseUploadIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      style={{ marginLeft: "8px" }}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.71 7.71L11 5.41V15C11 15.2652 11.1054 15.5196 11.2929 15.7071C11.4804 15.8946 11.7348 16 12 16C12.2652 16 12.5196 15.8946 12.7071 15.7071C12.8946 15.5196 13 15.2652 13 15V5.41L15.29 7.71C15.383 7.80373 15.4936 7.87812 15.6154 7.92889C15.7373 7.97966 15.868 8.0058 16 8.0058C16.132 8.0058 16.2627 7.97966 16.3846 7.92889C16.5064 7.87812 16.617 7.80373 16.71 7.71C16.8037 7.61704 16.8781 7.50644 16.9289 7.38458C16.9797 7.26272 17.0058 7.13201 17.0058 7C17.0058 6.86799 16.9797 6.73728 16.9289 6.61542C16.8781 6.49356 16.8037 6.38296 16.71 6.29L12.71 2.29C12.6149 2.19896 12.5028 2.12759 12.38 2.08C12.1365 1.97998 11.8635 1.97998 11.62 2.08C11.4972 2.12759 11.3851 2.19896 11.29 2.29L7.29 6.29C7.19676 6.38324 7.1228 6.49393 7.07234 6.61575C7.02188 6.73757 6.99591 6.86814 6.99591 7C6.99591 7.13186 7.02188 7.26243 7.07234 7.38425C7.1228 7.50607 7.19676 7.61676 7.29 7.71C7.38324 7.80324 7.49393 7.8772 7.61575 7.92766C7.73757 7.97812 7.86814 8.00409 8 8.00409C8.13186 8.00409 8.26243 7.97812 8.38425 7.92766C8.50607 7.8772 8.61676 7.80324 8.71 7.71ZM21 12C20.7348 12 20.4804 12.1054 20.2929 12.2929C20.1054 12.4804 20 12.7348 20 13V19C20 19.2652 19.8946 19.5196 19.7071 19.7071C19.5196 19.8946 19.2652 20 19 20H5C4.73478 20 4.48043 19.8946 4.29289 19.7071C4.10536 19.5196 4 19.2652 4 19V13C4 12.7348 3.89464 12.4804 3.70711 12.2929C3.51957 12.1054 3.26522 12 3 12C2.73478 12 2.48043 12.1054 2.29289 12.2929C2.10536 12.4804 2 12.7348 2 13V19C2 19.7956 2.31607 20.5587 2.87868 21.1213C3.44129 21.6839 4.20435 22 5 22H19C19.7956 22 20.5587 21.6839 21.1213 21.1213C21.6839 20.5587 22 19.7956 22 19V13C22 12.7348 21.8946 12.4804 21.7071 12.2929C21.5196 12.1054 21.2652 12 21 12Z"
        fill="white"
      />
    </svg>
  );
};

export const ArrowBackIcon = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        y="28"
        width="28"
        height="28"
        rx="4"
        transform="rotate(-90 0 28)"
        fill="#E24020"
        fillOpacity="0.06"
      />
      <path
        d="M16.3333 8.16671L10.5 14L16.3333 19.8334"
        stroke="#E24020"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ArrowForwardIcon = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="28"
        height="28"
        rx="4"
        transform="matrix(0 -1 -1 0 28 28)"
        fill="#E24020"
        fillOpacity="0.06"
      />
      <path
        d="M11.6667 8.16671L17.5 14L11.6667 19.8334"
        stroke="#E24020"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CheckboxBorder = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.75"
        y="0.75"
        width="14.5"
        height="14.5"
        rx="3.25"
        stroke="#B1B5C4"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export const TagsButtonIcon = (props) => {
  return (
    <svg
      width="7"
      height="12"
      viewBox="0 0 7 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ rotate: props.rotate }}
    >
      <path
        d="M6.47323 6.425C6.47323 6.55833 6.44852 6.68767 6.3991 6.813C6.34969 6.93833 6.2838 7.04233 6.20145 7.125L1.65537 11.725C1.47418 11.9083 1.24358 12 0.963571 12C0.683559 12 0.452961 11.9083 0.271776 11.725C0.0905918 11.5417 0 11.3083 0 11.025C0 10.7417 0.0905918 10.5083 0.271776 10.325L4.12606 6.425L0.271776 2.525C0.0905918 2.34167 0 2.10833 0 1.825C0 1.54167 0.0905918 1.30833 0.271776 1.125C0.452961 0.941668 0.683559 0.85 0.963571 0.85C1.24358 0.85 1.47418 0.941668 1.65537 1.125L6.20145 5.725C6.30028 5.825 6.37044 5.93333 6.41195 6.05C6.45346 6.16667 6.47389 6.29167 6.47323 6.425Z"
        fill="#686868"
      />
    </svg>
  );
};

export const DeletTagsIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.83203 17.5C5.3737 17.5 4.9812 17.3367 4.65453 17.01C4.32787 16.6833 4.16481 16.2911 4.16537 15.8333V5C3.92926 5 3.7312 4.92 3.5712 4.76C3.4112 4.6 3.33148 4.40223 3.33203 4.16667C3.33203 3.93056 3.41203 3.7325 3.57203 3.5725C3.73203 3.4125 3.92981 3.33278 4.16537 3.33334H7.4987C7.4987 3.09723 7.5787 2.89917 7.7387 2.73917C7.8987 2.57917 8.09648 2.49945 8.33203 2.5H11.6654C11.9015 2.5 12.0995 2.58 12.2595 2.74C12.4195 2.9 12.4993 3.09778 12.4987 3.33334H15.832C16.0681 3.33334 16.2662 3.41334 16.4262 3.57334C16.5862 3.73334 16.6659 3.93111 16.6654 4.16667C16.6654 4.40278 16.5854 4.60084 16.4254 4.76084C16.2654 4.92084 16.0676 5.00056 15.832 5V15.8333C15.832 16.2917 15.6687 16.6842 15.342 17.0108C15.0154 17.3375 14.6231 17.5006 14.1654 17.5H5.83203ZM5.83203 5V15.8333H14.1654V5H5.83203ZM7.4987 13.3333C7.4987 13.5694 7.5787 13.7675 7.7387 13.9275C7.8987 14.0875 8.09648 14.1672 8.33203 14.1667C8.56814 14.1667 8.7662 14.0867 8.9262 13.9267C9.0862 13.7667 9.16592 13.5689 9.16537 13.3333V7.5C9.16537 7.26389 9.08537 7.06584 8.92537 6.90584C8.76537 6.74584 8.56759 6.66611 8.33203 6.66667C8.09592 6.66667 7.89787 6.74667 7.73787 6.90667C7.57787 7.06667 7.49815 7.26445 7.4987 7.5V13.3333ZM10.832 13.3333C10.832 13.5694 10.912 13.7675 11.072 13.9275C11.232 14.0875 11.4298 14.1672 11.6654 14.1667C11.9015 14.1667 12.0995 14.0867 12.2595 13.9267C12.4195 13.7667 12.4993 13.5689 12.4987 13.3333V7.5C12.4987 7.26389 12.4187 7.06584 12.2587 6.90584C12.0987 6.74584 11.9009 6.66611 11.6654 6.66667C11.4293 6.66667 11.2312 6.74667 11.0712 6.90667C10.9112 7.06667 10.8315 7.26445 10.832 7.5V13.3333Z"
        fill="#E24020"
      />
    </svg>
  );
};

export const TherapistsIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 17.5C0 15.7319 0.67945 14.0362 1.88888 12.786C3.09831 11.5357 4.73865 10.8333 6.44904 10.8333C8.15943 10.8333 9.79976 11.5357 11.0092 12.786C12.2186 14.0362 12.8981 15.7319 12.8981 17.5H0ZM7.25517 12.5692V15.8333H11.0109C10.7228 14.9928 10.2227 14.2471 9.56243 13.6733C8.90216 13.0994 8.10563 12.7183 7.25517 12.5692ZM5.64291 15.8333V12.5692C4.79244 12.7183 3.99591 13.0994 3.33564 13.6733C2.67538 14.2471 2.17532 14.9928 1.88715 15.8333H5.64291ZM6.44904 10C3.77672 10 1.61226 7.7625 1.61226 5C1.61226 2.2375 3.77672 0 6.44904 0C9.12136 0 11.2858 2.2375 11.2858 5C11.2858 7.7625 9.12136 10 6.44904 10ZM6.44904 8.33333C8.23058 8.33333 9.67355 6.84167 9.67355 5C9.67355 3.15833 8.23058 1.66667 6.44904 1.66667C4.66749 1.66667 3.22452 3.15833 3.22452 5C3.22452 6.84167 4.66749 8.33333 6.44904 8.33333Z"
        fill={props.color}
      />
    </svg>
  );
};

export const PatientsIcon = (prop) =>{
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="20" height="20" fill="url(#pattern0)"/>
      <defs>
      <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
      <use href="#image0_1410_5226" transform="scale(0.0111111)"/>
      </pattern>
      <image id="image0_1410_5226" width="90" height="90" href="data:image/png;base64,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"/>
      </defs>
    </svg>

  )
}

export const FilterIcon = (props) => {
  return (
    <svg
      width="22"
      height="24"
      viewBox="0 0 22 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_854_4943)">
        <path
          d="M12.8333 18C12.5736 18 12.3558 17.904 12.1798 17.712C12.0038 17.52 11.9161 17.2827 11.9167 17C11.9167 16.7167 12.0047 16.479 12.1807 16.287C12.3567 16.095 12.5742 15.9993 12.8333 16H14.6667C14.9264 16 15.1443 16.096 15.3203 16.288C15.4963 16.48 15.5839 16.7173 15.5833 17C15.5833 17.2833 15.4953 17.521 15.3193 17.713C15.1433 17.905 14.9258 18.0007 14.6667 18H12.8333ZM6.41667 8C6.15695 8 5.93909 7.904 5.76309 7.712C5.58709 7.52 5.49939 7.28267 5.5 7C5.5 6.71667 5.588 6.479 5.764 6.287C5.94 6.095 6.15756 5.99934 6.41667 6H21.0833C21.3431 6 21.5609 6.096 21.7369 6.288C21.9129 6.48 22.0006 6.71734 22 7C22 7.28334 21.912 7.521 21.736 7.713C21.56 7.905 21.3424 8.00067 21.0833 8H6.41667ZM9.16667 13C8.90695 13 8.68909 12.904 8.51309 12.712C8.33709 12.52 8.24939 12.2827 8.25 12C8.25 11.7167 8.338 11.479 8.514 11.287C8.69 11.095 8.90756 10.9993 9.16667 11H18.3333C18.5931 11 18.8109 11.096 18.9869 11.288C19.1629 11.48 19.2506 11.7173 19.25 12C19.25 12.2833 19.162 12.521 18.986 12.713C18.81 12.905 18.5924 13.0007 18.3333 13H9.16667Z"
          fill={props.iconColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_854_4943">
          <rect width="22" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ProfileIcon = (props) => {
  return (
  <svg width="17" height="21" viewBox="0 0 17 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path 
      d="M8.5 2.5C10.154 2.5 11.5 3.846 11.5 5.5C11.5 7.154 10.154 8.5 8.5 8.5C6.846 8.5 5.5 7.154 5.5 5.5C5.5 3.846 6.846 2.5 8.5 2.5ZM8.5 0.5C5.736 0.5 3.5 2.738 3.5 5.5C3.5 8.262 5.736 10.5 8.5 10.5C11.264 10.5 13.5 8.262 13.5 5.5C13.5 2.738 11.264 0.5 8.5 0.5ZM8.5 13.5C11.6069 13.5 14.018 14.826 14.5 15.5C14.5 16.5 12.5 18.5 8.5 18.5C4.5 18.5 2.5 16 2.5 15.5C2.959 14.785 6 13.5 8.5 13.5ZM8.5 11.5C4.75 11.5 0.5 13.5 0.5 15.5C0.5 16.5 2.5 20.5 8.5 20.5C14 20.5 16.5 16.5 16.5 15.5C16.5 13.5 12.146 11.5 8.5 11.5Z" 
      fill={props.iconColor}/>
  </svg>
  );
};

export const LogsIcon = (props) => {
  return (
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path 
        d="M17.8465 13.6204L12.9628 18.8361C12.8648 18.9409 12.7318 18.9999 12.593 19H4.22093C3.89712 19 3.58657 18.8626 3.3576 18.6181C3.12863 18.3736 3 18.0419 3 17.6961L3 1.30392C3 0.958099 3.12863 0.626444 3.3576 0.38191C3.58657 0.137377 3.89712 0 4.22093 0H16.7791C17.1029 0 17.4134 0.137377 17.6424 0.38191C17.8714 0.626444 18 0.958099 18 1.30392V13.2255C17.9999 13.3736 17.9447 13.5157 17.8465 13.6204ZM16.7791 1.11765H4.22093C4.17467 1.11765 4.13031 1.13727 4.0976 1.1722C4.06489 1.20714 4.04651 1.25452 4.04651 1.30392L4.04651 17.6961C4.04651 17.7455 4.06489 17.7929 4.0976 17.8278C4.13031 17.8627 4.17467 17.8824 4.22093 17.8824H12.0698V13.2255C12.0698 13.0773 12.1249 12.9351 12.223 12.8303C12.3212 12.7255 12.4542 12.6667 12.593 12.6667L16.9535 12.6667V1.30392C16.9535 1.25452 16.9351 1.20714 16.9024 1.1722C16.8697 1.13727 16.8253 1.11765 16.7791 1.11765Z" 
        fill={props.iconColor}/>
      <rect y="5" width="15" height="7" rx="1" fill="white"/>
      <rect x="1" y="6" width="13" height="5" rx="1" fill={props.iconColor}/>
    </svg>
  );
};

export const ProgressIcon = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 4.5C0 4.22386 0.223858 4 0.5 4H3.5C3.77614 4 4 4.22386 4 4.5V16H0V4.5Z" fill={props.iconColor}/>
      <path d="M6 7.5C6 7.22386 6.22386 7 6.5 7H9.5C9.77614 7 10 7.22386 10 7.5V16H6V7.5Z" fill={props.iconColor}/>
      <path d="M12 0.5C12 0.223858 12.2239 0 12.5 0H15.5C15.7761 0 16 0.223858 16 0.5V16H12V0.5Z" fill={props.iconColor}/>
    </svg>
  );
};

export const ExerciseVideoIcon = () => {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.9974 5.77215H6.06073C5.74555 5.77215 5.43346 5.83432 5.14234 5.9551C4.85121 6.07587 4.58677 6.25289 4.36415 6.476C4.14153 6.69912 3.9651 6.96396 3.84497 7.25535C3.72484 7.54674 3.66337 7.85897 3.66407 8.17415V12.2822C3.66407 12.9178 3.91657 13.5274 4.36604 13.9769C4.58859 14.1994 4.85279 14.3759 5.14357 14.4964C5.43435 14.6168 5.746 14.6788 6.06073 14.6788H9.9974C10.633 14.6788 11.2426 14.4263 11.6921 13.9769C12.1416 13.5274 12.3941 12.9178 12.3941 12.2822V8.17482C12.395 7.8595 12.3337 7.54709 12.2137 7.2555C12.0937 6.96392 11.9173 6.69889 11.6947 6.47561C11.472 6.25234 11.2075 6.07521 10.9162 5.95438C10.625 5.83355 10.3127 5.7714 9.9974 5.77148M16.3307 8.51748V11.9408C16.3307 12.1075 16.2834 12.2715 16.1941 12.4128C16.1037 12.5547 15.9756 12.6685 15.8241 12.7415C15.6737 12.8168 15.5042 12.8455 15.3374 12.8242C15.1729 12.8045 15.0169 12.7405 14.8861 12.6388L12.7361 10.9135C12.6327 10.8286 12.5491 10.7222 12.4911 10.6016C12.4332 10.481 12.4024 10.3492 12.4007 10.2155C12.4007 10.0822 12.4307 9.95082 12.4894 9.83215C12.5507 9.72015 12.6347 9.62215 12.7361 9.54415L14.8861 7.83282C15.0169 7.73085 15.1733 7.66674 15.3381 7.64748C15.5047 7.62615 15.6741 7.65482 15.8241 7.72948C15.9734 7.8008 16.0999 7.9123 16.1894 8.05149C16.2789 8.19067 16.3278 8.35204 16.3307 8.51748Z" stroke="#D44C31" strokeWidth="0.7" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

export const RecordNoteIcon = (props) => {
  return (
    <svg width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path 
        d="M1.6067 13.2256C1.27812 13.2256 1.00384 13.1144 0.783839 12.8919C0.563363 12.669 0.453125 12.3914 0.453125 12.0592V1.39197C0.453125 1.05975 0.563363 0.782419 0.783839 0.559975C1.00384 0.337049 1.27812 0.225586 1.6067 0.225586H7.23884L10.4531 3.47559V12.0592C10.4531 12.3914 10.3431 12.6688 10.1231 12.8912C9.90265 13.1141 9.62813 13.2256 9.29955 13.2256H1.6067ZM6.8817 3.8367V0.947808H1.6067C1.49717 0.947808 1.39646 0.99403 1.30455 1.08647C1.21312 1.1794 1.16741 1.28123 1.16741 1.39197V12.0592C1.16741 12.1699 1.21312 12.2718 1.30455 12.3647C1.39646 12.4571 1.49717 12.5034 1.6067 12.5034H9.29955C9.40908 12.5034 9.50979 12.4571 9.6017 12.3647C9.69313 12.2718 9.73884 12.1699 9.73884 12.0592V3.8367H6.8817Z" 
        fill={props.iconColor}/>
    </svg>
  )
}

export const ViewEyeIcon = () => {
  return (
    <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.5 5.72559C10.5 6.38863 10.2366 7.02451 9.76777 7.49335C9.29893 7.96219 8.66304 8.22559 8 8.22559C7.33696 8.22559 6.70107 7.96219 6.23223 7.49335C5.76339 7.02451 5.5 6.38863 5.5 5.72559C5.5 5.06254 5.76339 4.42666 6.23223 3.95782C6.70107 3.48898 7.33696 3.22559 8 3.22559C8.66304 3.22559 9.29893 3.48898 9.76777 3.95782C10.2366 4.42666 10.5 5.06254 10.5 5.72559Z" fill="black"/>
      <path d="M0 5.72559C0 5.72559 3 0.225586 8 0.225586C13 0.225586 16 5.72559 16 5.72559C16 5.72559 13 11.2256 8 11.2256C3 11.2256 0 5.72559 0 5.72559ZM8 9.22559C8.92826 9.22559 9.8185 8.85684 10.4749 8.20046C11.1313 7.54408 11.5 6.65384 11.5 5.72559C11.5 4.79733 11.1313 3.90709 10.4749 3.25071C9.8185 2.59434 8.92826 2.22559 8 2.22559C7.07174 2.22559 6.1815 2.59434 5.52513 3.25071C4.86875 3.90709 4.5 4.79733 4.5 5.72559C4.5 6.65384 4.86875 7.54408 5.52513 8.20046C6.1815 8.85684 7.07174 9.22559 8 9.22559Z" fill="black"/>
    </svg>
  );
}

export const DateIcon = (props) => {
  return (
    <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.2 1.7H9V1.1C9 0.94087 8.93679 0.788258 8.82426 0.675736C8.71174 0.563214 8.55913 0.5 8.4 0.5C8.24087 0.5 8.08826 0.563214 7.97574 0.675736C7.86321 0.788258 7.8 0.94087 7.8 1.1V1.7H4.2V1.1C4.2 0.94087 4.13679 0.788258 4.02426 0.675736C3.91174 0.563214 3.75913 0.5 3.6 0.5C3.44087 0.5 3.28826 0.563214 3.17574 0.675736C3.06321 0.788258 3 0.94087 3 1.1V1.7H1.8C1.32261 1.7 0.864773 1.88964 0.527208 2.22721C0.189642 2.56477 0 3.02261 0 3.5V10.7C0 11.1774 0.189642 11.6352 0.527208 11.9728C0.864773 12.3104 1.32261 12.5 1.8 12.5H10.2C10.6774 12.5 11.1352 12.3104 11.4728 11.9728C11.8104 11.6352 12 11.1774 12 10.7V3.5C12 3.02261 11.8104 2.56477 11.4728 2.22721C11.1352 1.88964 10.6774 1.7 10.2 1.7ZM10.8 10.7C10.8 10.8591 10.7368 11.0117 10.6243 11.1243C10.5117 11.2368 10.3591 11.3 10.2 11.3H1.8C1.64087 11.3 1.48826 11.2368 1.37574 11.1243C1.26321 11.0117 1.2 10.8591 1.2 10.7V6.5H10.8V10.7ZM10.8 5.3H1.2V3.5C1.2 3.34087 1.26321 3.18826 1.37574 3.07574C1.48826 2.96321 1.64087 2.9 1.8 2.9H3V3.5C3 3.65913 3.06321 3.81174 3.17574 3.92426C3.28826 4.03679 3.44087 4.1 3.6 4.1C3.75913 4.1 3.91174 4.03679 4.02426 3.92426C4.13679 3.81174 4.2 3.65913 4.2 3.5V2.9H7.8V3.5C7.8 3.65913 7.86321 3.81174 7.97574 3.92426C8.08826 4.03679 8.24087 4.1 8.4 4.1C8.55913 4.1 8.71174 4.03679 8.82426 3.92426C8.93679 3.81174 9 3.65913 9 3.5V2.9H10.2C10.3591 2.9 10.5117 2.96321 10.6243 3.07574C10.7368 3.18826 10.8 3.34087 10.8 3.5V5.3Z" 
      fill={props.iconColor}/>
    </svg>
  );
}

export function RecordCloseIcon(props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 6L18 18"
        stroke={props.iconColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 6L6 18"
        stroke={props.iconColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export const BloodSugarIcon = () => {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="30" height="30" rx="15" fill="#F2F2F2"/>
      <path d="M15.8082 22.4978C15.4105 22.4978 15.0298 22.4153 14.6662 22.2503C14.3026 22.0853 13.9901 21.8496 13.7287 21.5432L10.4962 17.7813C10.1054 17.3265 10.1808 16.636 10.6605 16.2762C10.8878 16.1057 11.1435 16.0148 11.4276 16.0035C11.7116 15.9921 11.973 16.066 12.2116 16.2251C12.6177 16.4835 13.1491 16.1918 13.1491 15.7104V10.2251C13.1491 10.0319 13.2146 9.86983 13.3455 9.73892C13.4764 9.60801 13.6382 9.54278 13.831 9.54323C14.0241 9.54323 14.1862 9.60869 14.3171 9.7396C14.448 9.87051 14.5132 10.0323 14.5128 10.2251V15.8501C14.5128 16.1325 14.7417 16.3614 15.0241 16.3614C15.3066 16.3614 15.5355 16.1325 15.5355 15.8501V12.9523C15.5355 12.7591 15.601 12.5971 15.7319 12.4662C15.8628 12.3353 16.0246 12.2701 16.2173 12.2705C16.4105 12.2705 16.5726 12.336 16.7035 12.4669C16.8344 12.5978 16.8996 12.7596 16.8991 12.9523V15.8501C16.8991 16.1325 17.1281 16.3614 17.4105 16.3614C17.6929 16.3614 17.9219 16.1325 17.9219 15.8501V13.6341C17.9219 13.441 17.9873 13.2789 18.1182 13.148C18.2491 13.0171 18.411 12.9519 18.6037 12.9523C18.7969 12.9523 18.9589 13.0178 19.0898 13.1487C19.2207 13.2796 19.286 13.4414 19.2855 13.6341V15.8501C19.2855 16.1325 19.5145 16.3614 19.7969 16.3614C20.0793 16.3614 20.3082 16.1325 20.3082 15.8501V14.9978C20.3082 14.8046 20.3737 14.6426 20.5046 14.5116C20.6355 14.3807 20.7973 14.3155 20.9901 14.316C21.1832 14.316 21.3453 14.3814 21.4762 14.5123C21.6071 14.6432 21.6723 14.8051 21.6719 14.9978V19.7705C21.6719 20.5205 21.4048 21.1625 20.8707 21.6966C20.3366 22.2307 19.6946 22.4978 18.9446 22.4978H15.8082ZM9.05824 14.316C8.38778 14.316 7.82233 14.086 7.36188 13.626C6.90142 13.166 6.67142 12.6119 6.67188 11.9637C6.67188 11.5773 6.74869 11.2421 6.90233 10.958C7.05597 10.6739 7.41665 10.208 7.98438 9.56028C8.55153 8.9121 9.56938 8.92529 10.1321 9.57733C10.7116 10.2478 11.0753 10.7194 11.223 10.9921C11.3707 11.2648 11.4446 11.5887 11.4446 11.9637C11.4446 12.6114 11.2116 13.1655 10.7457 13.626C10.2798 14.0864 9.71733 14.3164 9.05824 14.316Z" fill="#4BA41A"/>
    </svg>
  );
} 


export const BloodPressIcon = () => {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="30" height="30" rx="15" fill="#F2F2F2"/>
      <path d="M8.33594 14.3422C8.33594 12.0893 9.83074 10 11.8778 10C13.5393 10 16.4662 10 18.1277 10C20.1748 10 21.6692 12.0896 21.6692 14.3422C21.6687 14.8188 21.0682 14.985 20.6711 14.7215C20.5187 14.6203 20.359 14.5298 20.1929 14.4508C19.6707 14.2022 19.0995 14.0735 18.5211 14.0741C16.3733 14.0741 14.6322 15.8152 14.6322 17.963C14.632 18.6929 14.8373 19.4081 15.2245 20.0269C15.3166 20.1741 15.4182 20.3144 15.5283 20.4471C16.0032 21.0195 15.7709 22.175 15.1179 22.531C14.8487 22.6777 14.8408 22.5143 14.5725 22.3661C13.0977 21.5517 8.33594 18.593 8.33594 14.3422Z" fill="#4BA41A"/>
      <path d="M19.4448 18.1495C19.4446 18.2521 19.4232 18.3536 19.3817 18.4475C19.3403 18.5414 19.2798 18.6257 19.204 18.6949C19.1283 18.7642 19.039 18.817 18.9418 18.8499C18.8446 18.8829 18.7416 18.8953 18.6394 18.8863C18.5371 18.8773 18.4378 18.8472 18.3479 18.7979C18.2579 18.7485 18.1791 18.681 18.1166 18.5996C18.0541 18.5182 18.0091 18.4247 17.9847 18.325C17.9388 18.1383 17.8935 17.9396 17.7575 17.8036L17.3401 17.3863C17.1954 17.2416 17.1955 17.007 17.3402 16.8624C17.4849 16.7178 17.7194 16.7179 17.864 16.8625L18.2029 17.2016C18.356 17.3547 18.5885 17.3865 18.8031 17.4155C18.9208 17.4314 19.033 17.4753 19.1302 17.5437C19.2273 17.612 19.3067 17.7027 19.3614 17.8082C19.4162 17.9136 19.4448 18.0307 19.4448 18.1495Z" fill="#4BA41A"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M21.6713 17.9636C21.6713 18.7985 21.3396 19.5993 20.7492 20.1897C20.1588 20.78 19.3581 21.1117 18.5231 21.1117C17.6882 21.1117 16.8875 20.78 16.2971 20.1897C15.7067 19.5993 15.375 18.7985 15.375 17.9636C15.375 17.1286 15.7067 16.3279 16.2971 15.7375C16.8875 15.1471 17.6882 14.8154 18.5231 14.8154C19.3581 14.8154 20.1588 15.1471 20.7492 15.7375C21.3396 16.3279 21.6713 17.1286 21.6713 17.9636ZM20.9305 17.9636C20.9305 18.6021 20.6769 19.2144 20.2254 19.6659C19.7739 20.1173 19.1616 20.371 18.5231 20.371C17.8846 20.371 17.2723 20.1173 16.8208 19.6659C16.3694 19.2144 16.1157 18.6021 16.1157 17.9636C16.1157 17.3251 16.3694 16.7128 16.8208 16.2613C17.2723 15.8098 17.8846 15.5562 18.5231 15.5562C19.1616 15.5562 19.7739 15.8098 20.2254 16.2613C20.6769 16.7128 20.9305 17.3251 20.9305 17.9636Z" fill="#4BA41A"/>
    </svg>
  );
}

export const BodyWeighIcon = () => {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="30" height="30" rx="15" fill="#F2F2F2"/>
      <path d="M12.25 13.4688C12.25 12.6068 12.5924 11.7801 13.2019 11.1707C13.8114 10.5612 14.638 10.2188 15.5 10.2188C16.362 10.2188 17.1886 10.5612 17.7981 11.1707C18.4076 11.7801 18.75 12.6068 18.75 13.4688C18.75 14.3307 18.4076 15.1574 17.7981 15.7668C17.1886 16.3763 16.362 16.7188 15.5 16.7188C14.638 16.7188 13.8114 16.3763 13.2019 15.7668C12.5924 15.1574 12.25 14.3307 12.25 13.4688ZM18.948 10.625C18.1279 9.63223 16.8889 9 15.5 9C14.1111 9 12.8721 9.63223 12.052 10.625H10.625C9.72871 10.625 9 11.3537 9 12.25V20.375C9 21.2713 9.72871 22 10.625 22H20.375C21.2713 22 22 21.2713 22 20.375V12.25C22 11.3537 21.2713 10.625 20.375 10.625H18.948ZM16.5156 14.6875C16.5156 14.4184 16.4115 14.1746 16.2389 13.9918L17.092 12.0037C17.1809 11.798 17.0844 11.5594 16.8787 11.4705C16.673 11.3816 16.4344 11.4781 16.3455 11.6838L15.4924 13.6719C14.9338 13.6744 14.4844 14.1289 14.4844 14.6875C14.4844 15.2486 14.9389 15.7031 15.5 15.7031C16.0611 15.7031 16.5156 15.2486 16.5156 14.6875Z" fill="#4BA41A"/>
    </svg>
  );
}

export const HourGlassIcon = () => {
  return (
    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.5542 11.6793C10.3322 9.57688 9.44128 8.70544 8.79052 8.06997C8.3406 7.62891 8.12427 7.3995 8.12427 7.00001C8.12427 6.60598 8.33984 6.38094 8.78849 5.94891C9.44687 5.31536 10.3485 4.44747 10.5547 2.31657C10.5711 2.13754 10.5525 1.95679 10.5001 1.78599C10.4476 1.6152 10.3624 1.45818 10.25 1.32508C10.1299 1.18293 9.98358 1.06943 9.82033 0.991911C9.65708 0.914391 9.48056 0.874567 9.30214 0.875007H3.6964C3.51774 0.874406 3.34094 0.914149 3.17742 0.991672C3.0139 1.06919 2.86729 1.18278 2.74704 1.32508C2.63498 1.45836 2.55011 1.61545 2.49789 1.78623C2.44567 1.957 2.42727 2.13767 2.44388 2.31657C2.64929 4.44063 3.54761 5.30223 4.20345 5.93114C4.65642 6.36563 4.87427 6.59231 4.87427 7.00001C4.87427 7.4129 4.65591 7.64423 4.20142 8.08692C3.55396 8.71856 2.66529 9.58344 2.44439 11.6793C2.42645 11.8576 2.44364 12.0378 2.49483 12.2084C2.54602 12.379 2.63006 12.536 2.74146 12.6692C2.86195 12.8132 3.00928 12.9282 3.17382 13.0067C3.33836 13.0852 3.51642 13.1256 3.6964 13.125H9.30214C9.48212 13.1256 9.66018 13.0852 9.82473 13.0067C9.98927 12.9282 10.1366 12.8132 10.2571 12.6692C10.3685 12.536 10.4525 12.379 10.5037 12.2084C10.5549 12.0378 10.5721 11.8576 10.5542 11.6793ZM8.71587 11.8125H4.29359C3.89749 11.8125 3.78577 11.3203 4.06355 11.0152C4.73589 10.2813 6.09302 9.75571 6.09302 8.91407V6.12501C6.09302 5.58223 5.12818 5.16798 4.53124 4.28751C4.43273 4.14231 4.44263 3.93751 4.69298 3.93751H8.31699C8.53052 3.93751 8.57648 4.14067 8.47949 4.28614C7.89118 5.16798 6.90552 5.5795 6.90552 6.12501V8.91407C6.90552 9.74887 8.32003 10.1992 8.94693 11.016C9.19956 11.3452 9.1112 11.8125 8.71587 11.8125Z" fill="#D44C31"/>
    </svg>
  );
}

export const ExerciseStatusIcon = () => {
  return (
  <svg width="52" height="51" viewBox="0 0 52 51" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="26" cy="25.5" r="25.5" fill="#D44C31" fillOpacity="0.04"/>
    <circle cx="26" cy="25.5" r="20.5" fill="#FFEAE5"/>
    <path d="M28.5385 20.6963C29.095 20.6963 29.6287 20.4752 30.0221 20.0817C30.4156 19.6883 30.6367 19.1546 30.6367 18.5981C30.6367 18.0417 30.4156 17.508 30.0221 17.1145C29.6287 16.7211 29.095 16.5 28.5385 16.5C27.9821 16.5 27.4484 16.7211 27.0549 17.1145C26.6614 17.508 26.4404 18.0417 26.4404 18.5981C26.4404 19.1546 26.6614 19.6883 27.0549 20.0817C27.4484 20.4752 27.9821 20.6963 28.5385 20.6963ZM24.3236 22.6928C23.7422 22.8373 23.3454 23.0546 23.0251 23.3241C22.5448 23.7288 22.1569 24.3125 21.6328 25.2301C21.5101 25.4449 21.3071 25.602 21.0685 25.6671C20.8299 25.7322 20.5752 25.6998 20.3604 25.577C20.1457 25.4543 19.9885 25.2513 19.9235 25.0127C19.8584 24.774 19.8908 24.5193 20.0135 24.3046C20.5353 23.3922 21.0626 22.5384 21.824 21.8978C22.6185 21.2283 23.5911 20.8497 24.9027 20.7037C25.451 20.6431 26.0543 20.6553 26.6199 20.9075C27.2134 21.1728 27.647 21.6479 27.9426 22.2829C28.3408 23.1376 28.6369 23.6463 28.8738 23.9414C28.988 24.0827 29.0677 24.1484 29.1129 24.1778C29.1488 24.2011 29.1642 24.203 29.1698 24.2039C29.2104 24.2086 29.3423 24.2039 29.7284 24.0328C29.8967 23.9582 30.0804 23.8687 30.3052 23.7591L30.3588 23.733C30.6336 23.5974 30.9109 23.4668 31.1906 23.3413C31.4163 23.2422 31.6722 23.2366 31.9021 23.3256C32.132 23.4146 32.3173 23.5911 32.4175 23.8164C32.5177 24.0416 32.5245 24.2974 32.4366 24.5278C32.3486 24.7581 32.1731 24.9443 31.9482 25.0455C31.6891 25.1618 31.4322 25.2829 31.1775 25.4087L31.1164 25.4385C30.9015 25.5435 30.6851 25.6493 30.4823 25.7388C30.0627 25.9244 29.5265 26.1258 28.9451 26.0554C28.3315 25.9808 27.8587 25.6344 27.4694 25.1695L26.1951 27.6281L27.9576 29.9211C28.0625 30.0582 28.1273 30.2214 28.1455 30.393L28.5334 34.1211C28.5482 34.2439 28.5384 34.3685 28.5045 34.4875C28.4707 34.6065 28.4135 34.7176 28.3363 34.8143C28.2592 34.911 28.1635 34.9913 28.055 35.0507C27.9464 35.11 27.8271 35.1472 27.7041 35.16C27.581 35.1728 27.4567 35.161 27.3382 35.1253C27.2198 35.0895 27.1096 35.0306 27.0142 34.9519C26.9187 34.8731 26.8399 34.7762 26.7823 34.6667C26.7247 34.5572 26.6895 34.4374 26.6786 34.3141L26.3178 30.8485L25.2472 29.4553L25.2379 29.4726L25.1987 29.3924L23.2209 26.8187C23.1237 26.6922 23.0605 26.5428 23.0375 26.3849C23.0145 26.2271 23.0324 26.0659 23.0894 25.9169L24.3236 22.6928Z" fill="#D44C31"/>
    <path d="M22.9093 28.1592L22.223 30.0055L19.5187 29.7911C19.3958 29.7796 19.2718 29.7928 19.1539 29.8297C19.0361 29.8665 18.9268 29.9265 18.8323 30.0059C18.7378 30.0854 18.66 30.1829 18.6035 30.2927C18.5469 30.4024 18.5128 30.5223 18.503 30.6454C18.4931 30.7685 18.5079 30.8923 18.5463 31.0097C18.5847 31.127 18.646 31.2356 18.7267 31.3291C18.8074 31.4225 18.9059 31.499 19.0164 31.5541C19.1269 31.6092 19.2473 31.6418 19.3705 31.65L22.7778 31.9204C22.9801 31.9365 23.182 31.8862 23.3531 31.7772C23.5241 31.6682 23.655 31.5063 23.7257 31.3162L24.2503 29.9044L22.9093 28.1592Z" fill="#D44C31"/>
  </svg>
  );
}

export const MedStatusIcon = () => {
  return (
    <svg width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="25.5" cy="25.5" r="25.5" fill="#D69C37" fillOpacity="0.04"/>
      <circle cx="25.5" cy="25.5" r="20.5" fill="#FFF0D5"/>
      <rect x="17" y="17" width="17" height="17" fill="url(#pattern0)"/>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
        <use href="#image0_203_29184" transform="scale(0.0111111)"/>
        </pattern>
        <image id="image0_203_29184" width="90" height="90" href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFgUlEQVR4nO2dTYgcRRSAy6jxF1QCelFB8bSCEXb7vRGjK15UEH/Rg0I8KKKiIBH0om4uSrwIAYnsvOqsqwi6IiQuBD1oVIi/wWx2u94kg2ElB1l/giS6GkEz8mYyZpOd7unZmemq7qkP6ra7U/31m9fVVa9qlfJ4PB6Px+PxeDweTzYcGB++gMvB7YZgk9HwAWtgo/EX1rhoCI6whgUmnGGN7zHBixXCm+YnRs/OqHv5pjZ13+lMeA8TbGfCv1ljrZNmCA8bjW8YHdxo+1qcpDamVpkQHmYN33cqN7YRfFUpB7fYvjZnqBAOG427eyZ4ufDtc1tHLlODSq2mTmONG1aSIjpvcMiU4U41oLlY91/wSfn7mCHcqAaF6uZbzzIap9PJgZ8NQTnSpQdNiLi3DJdGU0OrD06Vztkfjly5j0rXVwgfZQ3vMOEfKaW/ogZBMhPsSBF931Y03rtzbPSMtH975s1rzjOEjxuC+RQ38Fk12JLhEFPwkOTvlX6OjKWZ8IWk3C9pJNJ4hxpQyV9H48OX9+oz58ZHAiY8mCD7V0lFapAkG40fyle/158tIuWNMuGzt6mBiWSCHfJz/epDXXZCZOf+pSaaGlrdmKNIjuQs5icqOhhJyNnfqLxSdSCST0UmnmJveBluUHmj6qDkE6MR+CFmuDeh8kTVUclNWOMTrfuEv9nqU+EkCzKyiXuDzMXUajUHkpuwxqmYB/PzymUih0YXaTA6eCwmEN5VrlLNUSQ3iagEMf38TrlINYeSBZ4M1sR8635UrhHlLF0smwtvPcQ7olyimtNIPml9kvBYi34vKleo5lzy/2UMLfsOC8oFiiBZiMrBtTH9j5RtiiJZ4BDWOzllWiTJAmvY2voa8CVlizyPLlqxe3z4TFlZcWpeumiRLJiwdH/M0O6v6LXR81XWFFFybUytYo17Wn8r4f3MO1REyQJT6ZH49Ad3qTxKNuXgalnyN4STRgPVJ3ImgzXKEvvKcIXMOcc8Y/ZLtOdK8nyjpkIbjf8uz4N4WCpGVcZI7k0sogxhfa4kz9QrheDTxL/REL4x0/Izwo8SRkxfdlOs0xFSdtW2Fq5HkjlD2e2Cx2g4OhfCWpUFcjclj3YtWcPOtJKzkJ3mGxrp0lMqKyqEz3TzMrJ7fPhc1vhxp5JPyIZNNl6yWMNbmaUMqbRPLALvUyRzHyM7ZfnZdCdVqt3PySZvZ/g8C8ncQ9lOjv8bG3MS8lcIQ0npwvRQci9kOym5sZSTuPtpMVEy4Se9ltyNbCclC1JJ3+6CW9Up91syr0C2s5KF+mbJ9he8TZ7ezd+Z3bLuoiwkcweynZa8Z2Lthem3m9W3BL9sNL4qS/FZSeYUsp2WLMi+jayFcVeyl4+zc7EYIVu/bMvjThvh67JyXZdMpauY8DNnI7lJ2v19rjVD8A9r+Kn9TXFAckM0VGxL475FviOShePnXdiXonsc8bZz8qkYgj9tS+EiR3ITeeuzLkYXOJKbpHqg5KQZVyULhmDWtiAuumRB6hdsS+KiS263qTEXjRx88LUiKsPN1mXpAkdyE+mo1FfYlsZFjeSlyLlw1sXpgkbyUmSHqG15XORIXooh/MK6RF3QSF6KFF3bFslFjuQVLGn5SO4WOUayfiqXA3K5iJG8FDlGMmZzo5fca1jjc7YlmyI8+NIgK86N5SIrkqcLmS6Sx9ewkG1OxjCzgkPXHpBGw67+RzEcZYIn1SBz/JiFDY1z9PsieVdmlfZ5YGbLdRezhs0dHBdca9OiCgUPZFYAnjfqZWQhPC2v7abFbqvkBr8bjW+bEG/LdItZ3pklvITD4G4p1ZJ/yyG7mqRWxBAekGWy+oYhwlDOZ45CXCd7r2332ePxeDwej8fj8XjUoPAfiW9kV2n/+mgAAAAASUVORK5CYII="/>
      </defs>
    </svg>
  );
}

export const RightArrow = () => {
  return (
    <svg width="16" height="26" viewBox="0 0 16 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.3304 12.9985L0.000138849 2.66667L3.00881 0L16 12.9985L3.00881 26L0.333817 23L10.3304 12.9985Z" fill="black"/>
    </svg>
  );
}

export const PhoneIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.51667 6.99167C4.71667 9.35 6.65 11.275 9.00833 12.4833L10.8417 10.65C11.0667 10.425 11.4 10.35 11.6917 10.45C12.625 10.7583 13.6333 10.925 14.6667 10.925C15.125 10.925 15.5 11.3 15.5 11.7583V14.6667C15.5 15.125 15.125 15.5 14.6667 15.5C6.84167 15.5 0.5 9.15833 0.5 1.33333C0.5 0.875 0.875 0.5 1.33333 0.5H4.25C4.70833 0.5 5.08333 0.875 5.08333 1.33333C5.08333 2.375 5.25 3.375 5.55833 4.30833C5.65 4.6 5.58333 4.925 5.35 5.15833L3.51667 6.99167Z" fill="#E24020"/>
    </svg>
  );
}

export const GmailRedIcon = () => {
  return (
    <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.6641 11.9997H13.9974V4.70801L8.9974 7.83301L3.9974 4.70801V11.9997H2.33073V1.99967H3.33073L8.9974 5.54134L14.6641 1.99967H15.6641M15.6641 0.333008H2.33073C1.40573 0.333008 0.664062 1.07467 0.664062 1.99967V11.9997C0.664063 12.4417 0.839657 12.8656 1.15222 13.1782C1.46478 13.4907 1.8887 13.6663 2.33073 13.6663H15.6641C16.1061 13.6663 16.53 13.4907 16.8426 13.1782C17.1551 12.8656 17.3307 12.4417 17.3307 11.9997V1.99967C17.3307 1.55765 17.1551 1.13372 16.8426 0.821163C16.53 0.508602 16.1061 0.333008 15.6641 0.333008Z" fill="#E24020"/>
    </svg>
  );
}

export const PatientRedIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="20" height="20" fill="url(#pattern0)"/>
      <defs>
      <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
      <use href="#image0_1410_5226" transform="scale(0.0111111)"/>
      </pattern>
      <image id="image0_1410_5226" width="90" height="90" href="data:image/png;base64,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"/>
      </defs>
    </svg>

  )
}

export const PatientGreyIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="20" height="20" fill="url(#pattern0)"/>
      <defs>
      <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
      <use href="#image0_1628_1864" transform="scale(0.01)"/>
      </pattern>
      <image id="image0_1628_1864" width="100" height="100" href="data:image/png;base64,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"/>
      </defs>
    </svg>
  );
}

export const SendIcon = () => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21.2461 0.753732C21.128 0.636195 20.9788 0.554818 20.8161 0.519167C20.6533 0.483516 20.4838 0.495074 20.3274 0.552482L1.07738 7.55248C0.911363 7.61545 0.768434 7.72744 0.667573 7.87357C0.566713 8.01969 0.512695 8.19305 0.512695 8.37061C0.512695 8.54816 0.566713 8.72152 0.667573 8.86765C0.768434 9.01377 0.911363 9.12576 1.07738 9.18873L8.59363 12.19L14.1411 6.62498L15.3749 7.85873L9.80113 13.4325L12.8111 20.9487C12.876 21.1115 12.9882 21.2511 13.1333 21.3494C13.2784 21.4477 13.4496 21.5002 13.6249 21.5C13.8017 21.4964 13.9733 21.4392 14.117 21.3361C14.2607 21.233 14.3698 21.0888 14.4299 20.9225L21.4299 1.67248C21.4895 1.51767 21.5039 1.34911 21.4713 1.18644C21.4388 1.02377 21.3607 0.873703 21.2461 0.753732Z" fill="white"/>
    </svg>
  );
}

export const TickIcon = () =>{
  return (
    <svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2 7L5.2 10.125M9.68 5.125L12.88 2M7.12 7L10.32 10.125L18 2" stroke="#E24020" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export const ChatIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Communication / Chat_Conversation">
        <path id="Vector" d="M16 8H20C20.5523 8 21 8.44772 21 9V20L17.667 17.231C17.4875 17.0818 17.2608 17 17.0273 17H9C8.44771 17 8 16.5523 8 16V13M16 8V5C16 4.44772 15.5523 4 15 4H4C3.44772 4 3 4.44772 3 5V16.0003L6.33301 13.2308C6.51255 13.0817 6.73924 13 6.97266 13H8M16 8V12C16 12.5523 15.5523 13 15 13H8" stroke={props.color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
    </svg>
  );
}

export const EditDiagnosisIcon=(props)=>{
  return(
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M7 4C5.34315 4 4 5.34315 4 7V17C4 18.6569 5.34315 20 7 20H17C18.6569 20 20 18.6569 20 17V11C20 10.4477 20.4477 10 21 10C21.5523 10 22 10.4477 22 11V17C22 19.7614 19.7614 22 17 22H7C4.23858 22 2 19.7614 2 17V7C2 4.23858 4.23858 2 7 2H13C13.5523 2 14 2.44772 14 3C14 3.55228 13.5523 4 13 4H7Z" fill="black"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M19.1974 4C18.9845 4 18.7803 4.08457 18.6298 4.23509L10.7528 12.1121L10.3744 13.6256L11.8879 13.2473L19.7649 5.37021C19.9155 5.21969 20 5.01553 20 4.80265C20 4.58978 19.9155 4.38562 19.7649 4.23509C19.6144 4.08457 19.4102 4 19.1974 4ZM17.2156 2.82088C17.7412 2.29528 18.4541 2 19.1974 2C19.9407 2 20.6535 2.29528 21.1791 2.82088C21.7047 3.34648 22 4.05934 22 4.80265C22 5.54596 21.7047 6.25883 21.1791 6.78443L13.1062 14.8573C12.9781 14.9855 12.8175 15.0764 12.6417 15.1204L9.24256 15.9701C8.90178 16.0553 8.54129 15.9555 8.29291 15.7071C8.04453 15.4587 7.94468 15.0982 8.02988 14.7575L8.87966 11.3583C8.92362 11.1825 9.01453 11.0219 9.14269 10.8938L17.2156 2.82088Z" fill="black"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M15.2929 5.29289C15.6834 4.90237 16.3166 4.90237 16.7071 5.29289L18.7071 7.29289C19.0976 7.68342 19.0976 8.31658 18.7071 8.70711C18.3166 9.09763 17.6834 9.09763 17.2929 8.70711L15.2929 6.70711C14.9024 6.31658 14.9024 5.68342 15.2929 5.29289Z" fill="black"/>
    </svg>

  )
}

export const AccountIcon=(props)=>{
  if(props.type==="ACCOUNT_PAGE"){
    return(
      <svg xmlns="http://www.w3.org/2000/svg" width="60px" height="60px" viewBox="0 0 100 100">
        <circle cx="50" cy="50" r="50" fill="#F6F6F6"/>
        
        <g transform="translate(20, 20)">
          <svg xmlns="http://www.w3.org/2000/svg" height="60px" viewBox="0 -960 960 960" width="60px" fill="#7D7D7D">
            <path d="M444.62-404.62V-340q0 14.74 10.34 25.06 10.34 10.32 25.11 10.32 14.78 0 25.05-10.32 10.26-10.32 10.26-25.06v-64.62H580q14.74 0 25.06-10.34 10.32-10.34 10.32-25.11 0-14.78-10.32-25.05-10.32-10.26-25.06-10.26h-64.62V-540q0-14.74-10.34-25.06-10.34-10.32-25.11-10.32-14.78 0-25.05 10.32-10.26 10.32-10.26 25.06v64.62H380q-14.74 0-25.06 10.34-10.32 10.34-10.32 25.11 0 14.78 10.32 25.05 10.32 10.26 25.06 10.26h64.62ZM255.38-160q-22.25 0-38.81-16.57Q200-193.13 200-215.38v-336.93q0-13.67 5.51-25.07 5.51-11.41 16.95-19.08l224.62-169.62q13.89-11.23 32.64-11.23 18.74 0 33.2 11.23l224.62 169.62q11.44 7.67 16.95 19.08 5.51 11.4 5.51 25.07v336.93q0 22.25-16.57 38.81Q726.87-160 704.62-160H255.38Zm0-30.77h449.24q10.76 0 17.69-6.92 6.92-6.93 6.92-17.69V-554q0-6.15-2.69-11.54-2.69-5.38-7.31-8.46L494.62-739.92q-6.16-5.39-14.62-5.39-8.46 0-14.62 5.39L240.77-574q-4.62 3.08-7.31 8.46-2.69 5.39-2.69 11.54v338.62q0 10.76 6.92 17.69 6.93 6.92 17.69 6.92ZM480-468.92Z"/>
          </svg>
        </g>
      </svg>
    )
  }
  else if(props.type==="CLINIC_PAGE"){
    return(
        <svg xmlns="http://www.w3.org/2000/svg" height="28px" viewBox="0 -960 960 960" width="28px" fill="#FC6547">
          <rect x="10" y="-950" width="940" height="940" rx="80" ry="80"
                stroke="#FC6547" fill="none" strokeWidth="40"/>

          <path d="M444.62-404.62V-340q0 14.74 10.34 25.06 10.34 10.32 25.11 10.32 14.78 0 25.05-10.32 10.26-10.32 10.26-25.06v-64.62H580q14.74 0 25.06-10.34 10.32-10.34 10.32-25.11 0-14.78-10.32-25.05-10.32-10.26-25.06-10.26h-64.62V-540q0-14.74-10.34-25.06-10.34-10.32-25.11-10.32-14.78 0-25.05 10.32-10.26 10.32-10.26 25.06v64.62H380q-14.74 0-25.06 10.34-10.32 10.34-10.32 25.11 0 14.78 10.32 25.05 10.32 10.26 25.06 10.26h64.62ZM255.38-160q-22.25 0-38.81-16.57Q200-193.13 200-215.38v-336.93q0-13.67 5.51-25.07 5.51-11.41 16.95-19.08l224.62-169.62q13.89-11.23 32.64-11.23 18.74 0 33.2 11.23l224.62 169.62q11.44 7.67 16.95 19.08 5.51 11.4 5.51 25.07v336.93q0 22.25-16.57 38.81Q726.87-160 704.62-160H255.38Zm0-30.77h449.24q10.76 0 17.69-6.92 6.92-6.93 6.92-17.69V-554q0-6.15-2.69-11.54-2.69-5.38-7.31-8.46L494.62-739.92q-6.16-5.39-14.62-5.39-8.46 0-14.62 5.39L240.77-574q-4.62 3.08-7.31 8.46-2.69 5.39-2.69 11.54v338.62q0 10.76 6.92 17.69 6.93 6.92 17.69 6.92ZM480-468.92Z"/>
        </svg>
    )
  }
  else{
     return(
        <svg xmlns="http://www.w3.org/2000/svg" height="28px" viewBox="0 -960 960 960" width="28px" fill="#7D7D7D">
          <rect x="10" y="-950" width="940" height="940" rx="80" ry="80"
                stroke="none" fill="#F6F6F6" strokeWidth="40"/>

          <path d="M444.62-404.62V-340q0 14.74 10.34 25.06 10.34 10.32 25.11 10.32 14.78 0 25.05-10.32 10.26-10.32 10.26-25.06v-64.62H580q14.74 0 25.06-10.34 10.32-10.34 10.32-25.11 0-14.78-10.32-25.05-10.32-10.26-25.06-10.26h-64.62V-540q0-14.74-10.34-25.06-10.34-10.32-25.11-10.32-14.78 0-25.05 10.32-10.26 10.32-10.26 25.06v64.62H380q-14.74 0-25.06 10.34-10.32 10.34-10.32 25.11 0 14.78 10.32 25.05 10.32 10.26 25.06 10.26h64.62ZM255.38-160q-22.25 0-38.81-16.57Q200-193.13 200-215.38v-336.93q0-13.67 5.51-25.07 5.51-11.41 16.95-19.08l224.62-169.62q13.89-11.23 32.64-11.23 18.74 0 33.2 11.23l224.62 169.62q11.44 7.67 16.95 19.08 5.51 11.4 5.51 25.07v336.93q0 22.25-16.57 38.81Q726.87-160 704.62-160H255.38Zm0-30.77h449.24q10.76 0 17.69-6.92 6.92-6.93 6.92-17.69V-554q0-6.15-2.69-11.54-2.69-5.38-7.31-8.46L494.62-739.92q-6.16-5.39-14.62-5.39-8.46 0-14.62 5.39L240.77-574q-4.62 3.08-7.31 8.46-2.69 5.39-2.69 11.54v338.62q0 10.76 6.92 17.69 6.93 6.92 17.69 6.92ZM480-468.92Z"/>
        </svg>
    )
  }
  
}

export const DownloadIcon = () => {
  return (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.5 10V12.6667C14.5 13.0203 14.3595 13.3594 14.1095 13.6095C13.8594 13.8595 13.5203 14 13.1667 14H3.83333C3.47971 14 3.14057 13.8595 2.89052 13.6095C2.64048 13.3594 2.5 13.0203 2.5 12.6667V10" stroke="#8193A6" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5.16675 6.66663L8.50008 9.99996L11.8334 6.66663" stroke="#8193A6" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.5 10V2" stroke="#8193A6" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>)
}

export const CopyIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_344_342)">
        <path d="M13.3333 6H7.33333C6.59695 6 6 6.59695 6 7.33333V13.3333C6 14.0697 6.59695 14.6667 7.33333 14.6667H13.3333C14.0697 14.6667 14.6667 14.0697 14.6667 13.3333V7.33333C14.6667 6.59695 14.0697 6 13.3333 6Z" stroke="#8193A6" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M3.33325 10H2.66659C2.31296 10 1.97382 9.85956 1.72378 9.60952C1.47373 9.35947 1.33325 9.02033 1.33325 8.66671V2.66671C1.33325 2.31309 1.47373 1.97395 1.72378 1.7239C1.97382 1.47385 2.31296 1.33337 2.66659 1.33337H8.66659C9.02021 1.33337 9.35935 1.47385 9.60939 1.7239C9.85944 1.97395 9.99992 2.31309 9.99992 2.66671V3.33337" stroke="#8193A6" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_344_342">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>)
}